import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Resolver } from 'dns';
import { async } from '@angular/core/testing';
import { promise } from 'protractor';
import { isNullOrUndefined } from 'util';

import { SWAlertService } from '../../services/swalert.service';
import Swal from 'sweetalert2';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { log } from 'util';
import { DecimalPipe } from '@angular/common';


@Component({
  selector: 'app-admin-adjust',
  templateUrl: './admin-adjust.component.html',
  styleUrls: ['./admin-adjust.component.css']
})

export class AdminAdjustComponent implements OnInit {
  modalRef: BsModalRef;
  constructor(
    private System: TSFuntionService,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private swal: SWAlertService,
    private router: Router,
    private modalService: BsModalService,
    private _decimalPipe: DecimalPipe
  ) {
    Window["EVT_AdminAdjust"] = this;
  }


  ua = this.System.GetUserStorage();
  InputFrom: FormGroup;//สร้างกลุ่ม Object Data
  get _InputFrom() { return this.InputFrom.controls; }//ประกาศเพื่อใช้เรียกไปยัง From หน้าบ้าน
  get ListInvoice() { return this._InputFrom.ListInvoice as FormArray; }//Dynamic
  get ListGL() { return this._InputFrom.ListGL as FormArray; }//Dynamic
  PRMS = true;
  IsHidden = false;
  IsManualPost = false;
  PRMS_GRID = true;
  IsEditTaxBase = false;
  sHTMLFlow = "";
  sRequestCode = "";
  ArrBank = [];
  sRequestID = "";
  sInvoiceNo = "";
  TR_NoData = true;
  clicked: boolean  = false;
  hBranch = true;
  arrFIDoc: any;
  ArrRequest: any = {};
  ArrRequestItems = [];
  ArrPstKey = [];
  //ArrMaxLineNo = [];
  ArrVatPstKey = [];
  ArrVatType = [];
  ArrVatTypeVZ = [];
  ArrWHTType = [];
  ArrWHTCode = [];
  ArrCurrency = [];
  ArrBusinessArea = [];
  ArrBusinessPlace = [];
  ArrPAYMENT_METHOD = [];
  ArrVendorGL = [];
  ArrVendorCosCentor = [];
  ArrVendorIO = [];
  ArrVendorProfitCenter = [];

  ArrRecon = [];

  IsUploadExcelFile = false;
  arrExcel: any[] = [];
  IsNotFill_IO = false;
  NoInputGL = false;

  Todate = new Date();
  IsManual = false;
  IsReqUrgent = false;
  IsSSCUrgent = false;
  IsReverse = false;
  IsReverseError = false;
  IsOtherReq = false;
  sModalDetail: string = "";
  IsAdvanceReturnFull = false;
  IsPaymentFrom = true;
  IsForB2C = false;
  IsForB2P = false;
  IsForJV = false;
  EditInx = null;
  nReceiveType = 0

  isShowFIDoc: boolean = false;
  isShowClearingDoc: boolean = false;
  isShowAdvClearingDoc: boolean = false;
  isShowRecieveDoc: boolean = false;

  IsLoadingBankAll: boolean = false;
  DataBankBranch: any[] = [];

  isDisableReconAccount: boolean = false;
  isDisableIndividualPayee: boolean = true;
  ArrVendorName: any[] = [];

  _ArrCountry: any;
  _ArrProvince: any;
  _ArrAmphur: any;
  _ArrTumbon: any;

  async ngOnInit() {
    this.System.BlockUI();
    this.InputFrom = this.formBuilder.group({
      sRequestCode: null,
      nReqType: null,
      sCompCode: null,
      sDocHeader: [null, Validators.required],
      dDueDate_SSC: [new Date(), Validators.required],
      dPostingDate: [new Date(), Validators.required],
      dTranslationDate: [new Date(), Validators.required],
      sBusinessArea: ["", Validators.required],
      sBusinessPlace: ["", Validators.required],
      sPaymentType: 1,
      sBankOther: null,
      sBankName: ["", Validators.required],
      sAccountNo: ["", Validators.required],
      sPaymentMethodName: null,
      sPaymentMethod: null,
      sComment: null,
      sVendorName: ["", Validators.required],
      sVendorAddress: ["", Validators.required],
      sCountryID: null,
      sCountryName: ["", Validators.required],
      sProvCode: null,
      sProvName: ["", Validators.required],
      sAmpCode: null,
      sAmpName: ["", Validators.required],
      sTumbonCode: null,
      sTumbonName: ["", Validators.required],
      sPostCode: null,
      sPhoneNumber: null,
      sFaxNumber: null,
      sEmail: null,
      IsIndividualPayee: false,
      nOfficeType: 1,
      sVendorBranch: null,
      sTAXID: null,

      sVendorNamePayee: ["", Validators.required],
      sVendorAddressPayee: ["", Validators.required],
      sTAXIDPayee: null,
      nOfficeTypePayee: 1,
      sVendorBranchPayee: null,
      sCountryIDPayee: null,
      sCountryNamePayee: ["", Validators.required],
      sProvCodePayee: null, 
      sProvNamePayee: ["", Validators.required],
      sAmpCodePayee: null,
      sAmpNamePayee: ["", Validators.required],
      sTumbonCodePayee: null,
      sTumbonNamePayee: ["", Validators.required],
      sPostCodePayee: null,
      sPhoneNumberPayee: null,
      sFaxNumberPayee: null,
      sEmailPayee: null,	

      sPaymentTypePayee: 1,
      sBankOtherPayee: null,
      sBankNamePayee: ["", Validators.required],
      sAccountNoPayee: ["", Validators.required],
      sBankKeyPayee: [null],
      sBankKeyNamePayee: [null, Validators.required],
      sPaymentMethodNamePayee: null,
      sPaymentMethodPayee: null,

      sReconAccount: null,
      nGrandTotalAmtInvoice: null,
      ListInvoice: new FormArray([
        new FormGroup({
          sRequestID: new FormControl(null),
          nInvoiceType: new FormControl(null),
          nItemNo: new FormControl(null),
          sOtherRefNoFIDocNo: new FormControl(null),
          sInvoiceNo: new FormControl(null, Validators.required),
          sInvoiceNoDefault: new FormControl(null),
          dInvoiceDate: new FormControl(null, Validators.required),
          sVendorCode: new FormControl(null),
          sVendorName: new FormControl(null, Validators.required),
          sVendorAddress: new FormControl(null),
          sInvoiceDesc: new FormControl(null),
          sDescription: new FormControl(null),
          nExcludeVAT: new FormControl(null),
          sCurrency: new FormControl(null),
          sVATType: new FormControl(null, Validators.required),
          sVATTypeOld: new FormControl(null),
          nVATRate: new FormControl(null),
          nVAT: new FormControl(null),
          nIncludeVAT: new FormControl(null),
          nWHTVal: new FormControl(null),
          OGnWHTVal: new FormControl(null),
          sWHTType: new FormControl(null),
          sWHTCode: new FormControl(null),
          OGsWHTCode: new FormControl(null),
          nWHTRate: new FormControl(null),
          nWHTBase: new FormControl(null),
          OGnWHTBase: new FormControl(null),
          sWHTType2: new FormControl(null),
          sWHTCode2: new FormControl(null),
          OGsWHTCode2: new FormControl(null),
          nWHTRate2: new FormControl(null),
          nWHTVal2: new FormControl(null),
          OGnWHTVal2: new FormControl(null),
          nWHTBase2: new FormControl(null),
          OGnWHTBase2: new FormControl(null),
          sTAXID: new FormControl(null),
          NoData: new FormControl(null),
          IsVAT: new FormControl(null),
          IsVendorOneTime: new FormControl(null),
          sCountryID: new FormControl(null),
          sCountryName: new FormControl(null),
          sProvCode: new FormControl(null),
          sProvName: new FormControl(null),
          sAmpCode: new FormControl(null),
          sAmpName: new FormControl(null),
          sTumbonCode: new FormControl(null),
          sTumbonName: new FormControl(null),
          sPostCode: new FormControl(null),
          sPhoneNumber: new FormControl(null),
          sFaxNumber: new FormControl(null),
          sEmail: new FormControl(null),
          sVendorNamePayee: new FormControl(null),
          sVendorAddressPayee: new FormControl(null),
          sTAXIDPayee: new FormControl(null),
          nOfficeTypePayee: new FormControl(null),
          sVendorBranchPayee: new FormControl(null),
          sCountryIDPayee: new FormControl(null),
          sCountryNamePayee: new FormControl(null),
          sProvCodePayee: new FormControl(null), 
          sProvNamePayee: new FormControl(null),
          sAmpCodePayee: new FormControl(null),
          sAmpNamePayee: new FormControl(null),
          sTumbonCodePayee: new FormControl(null),
          sTumbonNamePayee: new FormControl(null),
          sPostCodePayee: new FormControl(null),
          sPhoneNumberPayee: new FormControl(null),
          sFaxNumberPayee: new FormControl(null),
          sEmailPayee: new FormControl(null),	
          sPaymentTypePayee: new FormControl(null),	
          sBankOtherPayee: new FormControl(null),	
          sBankNamePayee: new FormControl(null),	
          sAccountNoPayee: new FormControl(null),
          sBankKeyPayee: new FormControl(null),
          sBankKeyNamePayee: new FormControl(null),
          sPaymentMethodNamePayee: new FormControl(null),	
          sPaymentMethodPayee: new FormControl(null),	
          sReconAccount: new FormControl(null),
          IsIndividualPayee: new FormControl(false),
          nOfficeType: new FormControl(null),
          sVendorBranch: new FormControl(null),
          ListGL: new FormArray([
            new FormGroup({
              sRequestID: new FormControl(null),
              nItemNo: new FormControl(null),
              nLineNo: new FormControl(null),
              sDescription: new FormControl(null),
              sGL: new FormControl(null, Validators.required),
              sCCTR: new FormControl(null, Validators.required),
              sIO: new FormControl(null, Validators.required),
              sPTC: new FormControl(null),
              nAmtExcldVAT: new FormControl(null, Validators.required),
              nVAT: new FormControl(null, Validators.required),
              nAmtIncldVAT: new FormControl(null),
              sText: new FormControl(null, Validators.required),
              cActive: new FormControl(null),
              IsVAT: new FormControl(false),
              sRef: new FormControl(null),
              cSSC_Create: new FormControl("Y"),
              nReceiveType: new FormControl("1")
            })
          ]),
          ListPstkey: new FormArray([
            new FormGroup({
              nPstKeyID: new FormControl(null),
              sRequestID: new FormControl(null),
              nItemNo: new FormControl(null),
              nLineNo: new FormControl(null),
              sPstKy: new FormControl(null),
              sRefType: new FormControl(null),
              sRefCode: new FormControl(null),
              sPstType: new FormControl(null),
              sDescription: new FormControl(null),
              nAmountInDoc: new FormControl(null),
              sVATType: new FormControl(null),
              nTaxBase: new FormControl(null, Validators.required),
              sText: new FormControl(null),
              IsDelete: new FormControl(false),
              IsTaxBase: new FormControl(false),
              IsText: new FormControl(false),
              sRef: new FormControl(null),
            })
          ]),
          IsOpenPstKey: new FormControl(false)
        }),
      ]),
      IsHeader: true,
      IsColor: true,
      IsOpenPstKey: false
    })
    let ua = this.System.GetUserStorage();
    if (ua) {

    }
    let ID: string = this.System.GetQuerySTR('str');
    this.sRequestID = await this.System.Decrypt(ID);
    let ObjData = {
      sRequestID: this.sRequestID,
      nMenuID: 11
    }
    this.PRMS = await this.System.CheckPermission(ObjData);
    if (this.PRMS) {
      this.PRMS = await this.System.CheckPermissionMeun(11);
    }

    this.SetData();
    this.BindFlow();
    document.getElementById("adjust_tb_Resize").style.width = (document.getElementById("divResize").clientWidth - 5) + "px";
    document.getElementById("divFlowChart").style.width = (document.getElementById("divFlowResize").clientWidth - 5) + "px";
  }

  async SetData() {
    
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sRequestID", this.sRequestID)
    };
    let This = this;
    let res = await this.http.get<any>(this.System.SiteName + "api/AdminAdjust/SetData", httpOptions).toPromise()
    if (res) {
      let _Data = res[0][0];
      this.ArrRequest = res[0][0];
      this.IsNotFill_IO = res[4][0].IsNotFill_IO;
      let sPaymentType: number = 1;
      if (_Data.nStatusID == 11 || _Data.nStatusID == 12 || _Data.nStatusID == 13) {
        this.IsHidden = true;
      }
      if (_Data.nReqType == 10 || _Data.nReqType == 11 || _Data.nReqType == 12 || _Data.nReqType == 20 || _Data.nReqType == 30 || _Data.nReqType == 40 || _Data.nReqType == 60 || _Data.nReqType == 61) {
        this.IsManualPost = true;
      }
      if (this.PRMS) {
        if (_Data.nStatusID == 8 || _Data.nStatusID == 9 || _Data.nStatusID == 11) {

        }
        else {
          this.PRMS = false;
        }

      }

      switch (_Data.sPaymentType) {
        case "C":
          sPaymentType = 1;
          break;
        case "T":
        default:
          sPaymentType = 2;
          break;
      }

      this.InputFrom.patchValue({
        sCompCode: _Data.sCompCode,
        sBankName: this.System._ParseString(_Data.sBankName),
        sPaymentType: sPaymentType
      });
      await this.SetDataControl();

      let dPostingDate: Date = _Data.dPostingDate != null ? _Data.dPostingDate : new Date();
      let dTranslationDate: Date = _Data.dTranslationDate != null ? _Data.dTranslationDate : new Date();

      let sPaymentMethodName = "";
      let sPaymentMethod = "";
      this.cbPaymentType(sPaymentType, this.System._ParseString(_Data.sBankName), "B", '');
      if (this.System._ParseString(_Data.sPaymentMethod)) {
        var GetMethod = this.ArrPAYMENT_METHOD.filter(w => w.PAY_METHOD == _Data.sPaymentMethod);
        if (GetMethod) {
          sPaymentMethodName = GetMethod.length > 0 ? GetMethod[0].PAY_METHOD_DESC : "";
          sPaymentMethod = GetMethod.length > 0 ? GetMethod[0].PAY_METHOD : "";
          this.InputFrom.patchValue({
            sPaymentMethodName: sPaymentMethodName,
            sPaymentMethod: sPaymentMethod
          })
        }
      }



      if (_Data.nReqType === 20) {
        this.isDisableReconAccount = true;
      }
      if (_Data.nReqType === 10) {
        this.isDisableIndividualPayee = false;
      }
      this.IsUploadExcelFile = _Data.IsUploadExcelFile;

      if (this.IsUploadExcelFile == true) {
        let addText = '';
        if (_Data.nReqType == '80') {
          addText = 'JV';
        }
        let data;
        await this.http.get(this.System.SiteName + "api/_Paytovendor/GetRequestExcel" + addText + "/" + this.sRequestID + "").toPromise().then(Data => data = Data)
        for (var i = 0; i < data.length; i++) {
          if (_Data.nReqType == '80') {
            let chunks2 = data[i].sPostingDate.split("/");
            var sPostingDate = new Date(chunks2[2], chunks2[1] - 1, chunks2[0]);
            data[i].sPostingDate = sPostingDate;
          }
          else {
            let chunks1 = data[i].dInvoiceDate.split("/");
            let chunks2 = data[i].dPostingDate.split("/");
            let chunks3 = data[i].dDueDate.split("/");
            data[i].sNo = (i + 1).toString();
            var dInvoiceDate = new Date(chunks1[2], chunks1[1] - 1, chunks1[0]);
            var dPostingDate2 = new Date(chunks2[2], chunks2[1] - 1, chunks2[0]);
            var dDueDate = new Date(chunks3[2], chunks3[1] - 1, chunks3[0]);
            data[i].dInvoiceDate = dInvoiceDate;
            data[i].dPostingDate = dPostingDate2;
            data[i].dDueDate = dDueDate;
          }
        
        }
        this.arrExcel = data;
      }

      this.InputFrom.patchValue({
        sRequestCode: _Data.sRequestCode,
        nReqType: _Data.nReqType,
        nInvoiceType: _Data.nInvoiceType,
        sDocHeader: _Data.sDocHeader,
        dDueDate_SSC: _Data.dDueDate_SSC != null ? new Date(_Data.dDueDate_SSC) : new Date(_Data.dDueDate),
        dPostingDate: new Date(dPostingDate),
        dTranslationDate: new Date(dTranslationDate),
        sBusinessArea: _Data.sBusinessArea,
        sBusinessPlace: this.System._ParseString(_Data.sBusinessPlace) != "" ? _Data.sBusinessPlace : "0000",
        sPaymentType: sPaymentType,
        sBankOther: _Data.sBankOther,
        sBankName: this.System._ParseString(_Data.sBankName),
        sAccountNo: this.System._ParseString(_Data.sAccountNo),
        sComment: _Data.sComment,
        nGrandTotalAmtInvoice: this._ConvertToDecimal(_Data.nGrandTotalAmtInvoice)
      })

      this.IsManual = _Data.IsManual;
      this.IsReqUrgent = _Data.IsReqUrgent;
      this.IsSSCUrgent = _Data.IsSSCUrgent;
      this.IsReverse = _Data.IsReverse;
      this.IsReverseError = _Data.IsReverseError;
      this.nReceiveType = _Data.nReceiveType;


      let _ListInvoice = res[1];
      let _ListGL = res[2];

      //let _ListPstKey = res[3];
      this.ArrPstKey = res[3];
      this.ListInvoice.clear();
      _ListInvoice.forEach( async function (Item, i) {
         This.ListInvoice.push(await This.SetFormGroupInArray(Item, _ListGL));
      });

      this.ArrRequestItems = res[5];

      this.PRMS_GRID = this.PRMS;
      switch (_Data.nReqType) {
        case 20://Advance to Employee
          this.NoInputGL = true;
          this.IsPaymentFrom = false;
          this.InputFrom.get("sPaymentType").disable();
          this.InputFrom.get("sBankOther").disable();
          this.InputFrom.get("sBankName").disable();
          this.InputFrom.get("sAccountNo").disable();
          this.InputFrom.get("sPaymentMethodName").disable();
          break;
        case 70://Billing to Cash
        case 71:
          this.IsOtherReq = true;
          this.IsPaymentFrom = false;
          this.IsForB2C = true;
          this.InputFrom.get("sPaymentType").disable();
          this.InputFrom.get("sBankOther").disable();
          this.InputFrom.get("sBankName").disable();
          this.InputFrom.get("sAccountNo").disable();
          this.InputFrom.get("sPaymentMethodName").disable();
          break;
          case 80://Journal Voucher
          this.IsOtherReq = true;
          this.IsPaymentFrom = false;
          this.IsForB2C = true;
          this.IsForJV = true;
          this.InputFrom.get("sPaymentType").disable();
          this.InputFrom.get("sBankOther").disable();
          this.InputFrom.get("sBankName").disable();
          this.InputFrom.get("sAccountNo").disable();
          this.InputFrom.get("sPaymentMethodName").disable();
          break;
        case 90://Receipt Voucher
          this.IsOtherReq = true;
          this.IsPaymentFrom = false;
          this.IsForB2P = true;
          this.InputFrom.get("sPaymentType").disable();
          this.InputFrom.get("sBankOther").disable();
          this.InputFrom.get("sBankName").disable();
          this.InputFrom.get("sAccountNo").disable();
          this.InputFrom.get("sPaymentMethodName").disable();
          break;

          
        case 50:
          this.PRMS_GRID = true;
          this.IsOtherReq = true;
          break;
        case 30:
          if (_Data.nInvoiceType == 3) {
            this.IsAdvanceReturnFull = true;
            this.NoInputGL = true;
          }
          else {
            this.IsEditTaxBase = this.PRMS ? true : false;
            this.NoInputGL = false;
            this.BindTable();
          }

          //Close Payment From
          this.IsPaymentFrom = false;
          this.InputFrom.get("sPaymentType").disable();
          this.InputFrom.get("sBankOther").disable();
          this.InputFrom.get("sBankName").disable();
          this.InputFrom.get("sAccountNo").disable();
          this.InputFrom.get("sPaymentMethodName").disable();
          break;
        default:
          this.IsEditTaxBase = this.PRMS ? true : false;
          this.NoInputGL = false;
          this.BindTable();
          break;
      }
    }

    this.System.UnBlockUI();
  }
  _ConvertToDecimal(sVal) {
    if (!sVal) sVal = '';
    let NoComma = (sVal + "").replace(/,/g, "");//ตัด Comma ออก
    let Data = this._decimalPipe.transform(NoComma, "1.2-2");
    return Data;
  }


  //#region WorkFlow
  ArrFlow = []
  BindFlow() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sRequestID", this.sRequestID)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/BindFlow", httpOptions).subscribe(res => {
      if (res) {
        this.ArrFlow = res;
        let width: number = this.ArrFlow.length * 240;
        document.getElementById("DIV_FLOW").style.width = width + "px";
      }
    });
  }
  FlowICO(Item) {
    let sColor = "";
    switch (Item.cApprove) {
      case "A":
        sColor = Item.nFlowNo == 1 ? "fas fa-user-edit _flow_icon _text_green_paster" : "fas fa-user-check _flow_icon _text_green_paster";
        break;
      case "R":
        sColor = "fas fa-user-times _flow_icon _text_red_paster";
        break;
      case "W":
        sColor = "fas fa-user-clock _flow_icon _text_orange_paster";
        break;
    }
    return sColor;
  }
  FlowCommentDisplay(_Item, sCase) {
    let Display = false;
    switch (sCase) {
      case "1":
        if (_Item.sComment) {
          Display = (_Item.sComment.length > 15 ? false : true);
        }
        else {
          Display = true;
        }
        break;
      case "2":
        if (_Item.sComment) {
          Display = (_Item.sComment.length < 15 ? false : true);
        }
        break;
    }
    return Display;
  }
  //#endregion

  async SetFormGroupInArray(_Item, _ItemGL) {
    let This = this;
    let _sRequestID: string = "";
    let _sItemNo: string = "";
    let _sOtherRefNoFIDocNo: string = "";
    let _sInvoiceNo: string = "";
    let _sInvoiceNoDefault: string = "";
    let _dInvoiceDate: Date = null;
    let _sInvoiceDate: string = "";
    let _sVendorCode: string = "";
    let _sVendorName: string = "";
    let _sVendorAddress: string = "";
    let _sInvoiceDesc: string = "";
    let _sDescription: string = "";
    let _sExcludeVAT: string = "";
    let _sCurrency: string = "";
    let _sVATType: string = "";
    let _sVATTypeOld: string = "";
    let _nVATRate: any = null;
    let _sVAT: string = "";
    let _sIncludeVAT: string = "";
    let _nWHTVal: string = "";
    let _nWHTVal2: string = "";
    let _sWHTType: string = "";
    let _sWHTType2: string = "";
    let _sWHTCode: string = "";
    let _sWHTCode2: string = "";
    let _sWHTRate: string = "";
    let _sWHTRate2: string = "";
    let _nWHTBase: string = "";
    let _nWHTBase2: string = "";
    let _sTAXID: string = "";
    let _sCountryID: string = "";
    let _sCountryName: string = "";
    let _sProvCode: string = "";
    let _sProvName: string = "";
    let _sAmpCode: string = "";
    let _sAmpName: string = "";
    let _sTumbonCode: string = "";
    let _sTumbonName: string = "";
    let _sPostCode: string = "";
    let _sPhoneNumber: string = "";
    let _sFaxNumber: string = "";
    let _sEmail: string = "";
    let _sVendorNamePayee: string = "";
    let _sVendorAddressPayee: string = "";
    let _sTAXIDPayee: string = "";
    let _nOfficeTypePayee: string = "";
    let _sVendorBranchPayee: string = "";
    let _sCountryIDPayee: string = "";
    let _sCountryNamePayee: string = "";
    let _sProvCodePayee: string = "";
    let _sProvNamePayee: string = "";
    let _sAmpCodePayee: string = "";
    let _sAmpNamePayee: string = "";
    let _sTumbonCodePayee: string = "";
    let _sTumbonNamePayee: string = "";
    let _sPostCodePayee: string = "";
    let _sPhoneNumberPayee: string = "";
    let _sFaxNumberPayee: string = "";
    let _sPaymentTypePayee: any = "";
    let _sBankOtherPayee: string = "";
    let _sBankNamePayee: string = "";
    let _sAccountNoPayee: string = "";
    let _sBankKeyPayee: string = "";
    let _sBankKeyNamePayee: string = "";
    let _sPaymentMethodNamePayee: string = "";
    let _sPaymentMethodPayee: string = "";
    let _sEmailPayee: string = "";
    let _sReconAccount: string = "";
    let _IsIndividualPayee: boolean = false;
    let _nOfficeType: number = 1;
    let _sVendorBranch: string = "";

    let _nInvoiceType = null;
    let _ArrGL = new FormArray([]);
    let _ArrPstkey = new FormArray([]);

    let IsVAT: boolean = true;
    let IsDisabledFormCustom: boolean = false;

    let NoData: boolean = true;
    let IsVendorOneTime: boolean = false;
    let IsValidators = Validators.required;
    if (_Item) {
      _sRequestID = _Item.sRequestID;
      _sItemNo = _Item.nItemNo;
      _sOtherRefNoFIDocNo = _Item.sOtherRefNoFIDocNo;
      _sInvoiceNo = _Item.sInvoiceNo;
      _sInvoiceNoDefault = _Item.sInvoiceNo;
      _dInvoiceDate = new Date(_Item.dInvoiceDate);
      _sInvoiceDate = this.System._ParseDateToFormat(new Date(_Item.dInvoiceDate), "");
      _sVendorCode = _Item.sVendorCode;
      _sVendorName = _Item.sVendorName;
      _sVendorAddress = _Item.sVendorAddress;
      _sVendorNamePayee = _Item.sVendorNamePayee;
      _sVendorAddressPayee = _Item.sVendorAddressPayee;
      _sInvoiceDesc = _Item.sInvoiceDesc;
      _sDescription = _Item.sDescription;
      _sExcludeVAT = this.System._ParseToDecimal(_Item.nExcludeVAT);
      _sCurrency = _Item.sCurrency;
      _sVATType = this.System._ParseString(_Item.sVATType);
      _sVATTypeOld = this.System._ParseString(_Item.sVATType);

      if (_sVATType == "VZ" || _sVATType == "Blank") {
        this.ArrVatTypeVZ = this.ArrVatType.filter(item => item.TAX_CODE == "VZ" || item.TAX_CODE == "Blank")
      }


      _nVATRate = _Item.nVATRate;
      _sVAT = this.System._ParseToDecimal(_Item.nVAT);
      _sIncludeVAT = this.System._ParseToDecimal(_Item.nIncludeVAT);
      _nWHTVal = this.System._ParseToDecimal(_Item.nWHTVal);
      _nWHTVal2 = this.System._ParseToDecimal(_Item.nWHTVal2);
      //คณะทำงานแจ้งให้ระบบ Default WHT type เป็น P1 ในกรณีที่พนักงาน RO กรอก WHT code มา
      if (_Item.sWHTType) {
        _sWHTType = _Item.sWHTType;
      }
      else {
        if (_Item.nWHTID) {
          _sWHTType = "P1";
        }
      }
      if (_Item.sWHTType2) {
        _sWHTType2 = _Item.sWHTType2;
      }
     
      _sWHTCode = this.System._ParseString(_Item.sWHTCode);
      _sWHTCode2 = this.System._ParseString(_Item.sWHTCode2);
      _sWHTRate = this.System._ParseToDecimal(_Item.nWHTRate);
      _sWHTRate2 = this.System._ParseToDecimal(_Item.nWHTRate2);

      if (_Item.nWHTBase) {
        _nWHTBase = this.System._ParseToDecimal(_Item.nWHTBase);
      }
      else {
        if (_Item.nWHTID) {
          _nWHTBase = this.System._ParseToDecimal(_Item.nExcludeVAT);
        }
      }
      if (_Item.nWHTBase2) {
        _nWHTBase2 = this.System._ParseToDecimal(_Item.nWHTBase2);
      }
      else {
        if (_Item.nWHTID2) {
          _nWHTBase2 = this.System._ParseToDecimal(_Item.nExcludeVAT);
        }
      }

      _sTAXID = _Item.sTAXID;

      _sCountryID = this.System._ParseString(_Item.sCountryID);
      _sCountryName = this.System._ParseString(_Item.sCountryName);
      _sProvCode = this.System._ParseString(_Item.sProvCode);
      _sProvName = this.System._ParseString(_Item.sProvName);
      _sAmpCode = this.System._ParseString(_Item.sAmpCode);
      _sAmpName = this.System._ParseString(_Item.sAmpName);
      _sTumbonCode = this.System._ParseString(_Item.sTumbonCode);
      _sTumbonName = this.System._ParseString(_Item.sTumbonName);
      _sPostCode = this.System._ParseString(_Item.sPostCode);
      _sPhoneNumber = this.System._ParseString(_Item.sPhoneNumber);
      _sFaxNumber = this.System._ParseString(_Item.sFaxNumber);
      _sEmail = this.System._ParseString(_Item.sEmail);
      _sReconAccount = this.System._ParseString(_Item.sReconAccount)
      _IsIndividualPayee = _Item.IsIndividualPayee
      _nOfficeType = _Item.nOfficeType
      _sVendorBranch = this.System._ParseString(_Item.sVendorBranch)

      _sTAXIDPayee = _Item.sTAXIDPayee;
      _sCountryIDPayee = this.System._ParseString(_Item.sCountryIDPayee);
      _sCountryNamePayee = this.System._ParseString(_Item.sCountryNamePayee);
      _sProvCodePayee = this.System._ParseString(_Item.sProvCodePayee);
      _sProvNamePayee = this.System._ParseString(_Item.sProvNamePayee);
      _sAmpCodePayee = this.System._ParseString(_Item.sAmpCodePayee);
      _sAmpNamePayee = this.System._ParseString(_Item.sAmpNamePayee);
      _sTumbonCodePayee = this.System._ParseString(_Item.sTumbonCodePayee);
      _sTumbonNamePayee = this.System._ParseString(_Item.sTumbonNamePayee);
      _sPostCodePayee = this.System._ParseString(_Item.sPostCodePayee);
      _sPhoneNumberPayee = this.System._ParseString(_Item.sPhoneNumberPayee);
      _sFaxNumberPayee = this.System._ParseString(_Item.sFaxNumberPayee);
      _sEmailPayee = this.System._ParseString(_Item.sEmailPayee);
      _nOfficeTypePayee = _Item.nOfficeTypePayee
      _sVendorBranchPayee = this.System._ParseString(_Item.sVendorBranchPayee)

      _sPaymentTypePayee = this.System._ParseString(_Item.sPaymentTypePayee)
      _sBankOtherPayee =this.System._ParseString(_Item.sBankOtherPayee)
      _sBankNamePayee = this.System._ParseString(_Item.sBankNamePayee)
      _sAccountNoPayee =this.System._ParseString(_Item.sAccountNoPayee)
      _sBankKeyPayee =this.System._ParseString(_Item.sBankKeyPayee)
      _sPaymentMethodPayee = this.System._ParseString(_Item.sPaymentMethodPayee + '')



      let bankArr: any = await this.http.get(this.System.SiteName + "api/Autocomplete/MT_BANKKEY/NAME_OF_BANK/BANK_KEY/" + _sBankKeyPayee).toPromise();
      if (_sAccountNoPayee === "N/A") {
        bankArr = [{NAME_OF_BANK: "N/A"}]
      }
      if (bankArr) {
        _sBankKeyNamePayee = (bankArr.length > 0) ? bankArr[0].NAME_OF_BANK : _Item.sValue == "Y" && _sBankKeyPayee == "N/A" ? "N/A" : "";

      }

      let sPaymentTypePayee: number = 1;

      switch (_sPaymentTypePayee) {
        case "C":
          sPaymentTypePayee = 1;
          break;
        case "T":
        default:
          sPaymentTypePayee = 2;
          break;
      }
      var paymentMethod = this.cbPaymentType(sPaymentTypePayee, this.System._ParseString(_sBankNamePayee), "B", 'Payee');
      _sPaymentTypePayee = sPaymentTypePayee;

      _sPaymentMethodPayee = paymentMethod.sPaymentMethod + '';
      _sPaymentMethodNamePayee = paymentMethod.sPaymentMethodName;
      
      _nInvoiceType = _Item.nInvoiceType;
      let _VatRate = this.System._ParseFloatToZero(_Item.nVATRate);

      //เช็คกรณี Vat เป้น null
      if (this.PRMS_GRID) {
        if (_nVATRate == null || _nVATRate + "" == "") {
          IsVAT = false;
        }
        else {
          IsVAT = true;
        }
      }
      else {
        IsVAT = true;
      }

      let nReqType: number = 0;
      nReqType = this.InputFrom.controls["nReqType"].value;
      switch (nReqType) {
        case 30://Clear Advance
        case 40://Petty Cash
          if (_nInvoiceType == 2) {
            IsValidators = null;
          }
          break;
        case 50://Other
          IsDisabledFormCustom = true;
          IsVAT = true;
          break;
        default:
          break;
      }

      //เช็คกรณี No Vat OR WHT
      if (_nInvoiceType == 2) {

      }

      let ArrGL = _ItemGL.filter(f => f.nItemNo == _sItemNo && f.cActive == "Y");
      NoData = ArrGL.length == 0;
      IsVendorOneTime = this.PRMS_GRID ? _Item.IsVendorOneTime : false;
      ArrGL.forEach(function (Item) {
        let _nAmtExcldVAT = This.System._ParseFloatToZero(Item.nAmtExcldVAT);
        let _nVAT = Item.nVAT == null ? This.System._ParseFloatToZero(_nAmtExcldVAT * _VatRate) : This.System._ParseFloatToZero(Item.nVAT);
        let _nAmtIncldVAT = Item.nAmtIncldVAT == null ? This.System._ParseFloatToZero(_nAmtExcldVAT + _nVAT) : This.System._ParseFloatToZero(Item.nAmtIncldVAT);
        let _sIO = (Item.sIO === '' || Item.sIO === null) ? 'Not Require IO (N/A)' : Item.sIO;
        //if (!IsVAT) {
        //  _nVAT = null;
        //}
        _ArrGL.push(new FormGroup({
          sRequestID: new FormControl(Item.sRequestID),
          nItemNo: new FormControl(Item.nItemNo),
          nLineNo: new FormControl(Item.nLineNo),
          sDescription: new FormControl(Item.sDescription),
          sGL: nReqType === 90 ? new FormControl(Item.sGL) : new FormControl(Item.sGL, Validators.required),
          sCCTR: nReqType === 70 || nReqType === 71 || nReqType === 80 || nReqType === 90 ? new FormControl(Item.sCCTR) : new FormControl(Item.sCCTR, Validators.required),
          sIO: nReqType === 70 || nReqType === 71 || nReqType === 80 || nReqType === 90 || This.IsNotFill_IO ? new FormControl({ value: _sIO, disabled: This.IsNotFill_IO }) : new FormControl(_sIO, Validators.required),
          //sPTC: nReqType === 70 || nReqType === 80 ? new FormControl(Item.sPTC) : new FormControl(Item.sPTC, Validators.required),
          //sIO: new FormControl({ value: Item.sIO, disabled: This.IsNotFill_IO }, Validators.required),
          sPTC: new FormControl(Item.sPTC),
          nAmtExcldVAT: new FormControl(This.System._ParseToDecimal(_nAmtExcldVAT)),
          nVAT: new FormControl({ value: This.System._ParseToDecimal(_nVAT), disabled: !IsVAT }, Validators.required),
          nAmtIncldVAT: new FormControl(This.System._ParseToDecimal(_nAmtIncldVAT)),
          sText: new FormControl(Item.sText, Validators.required),
          cActive: new FormControl(Item.cActive),
          IsVAT: new FormControl(IsVAT),
          sRef: new FormControl(null),
          cSSC_Create: new FormControl(Item.cSSC_Create),
          nReceiveType: new FormControl(Item.nReceiveType != null ? Item.nReceiveType.toString() : "1")
        }));
      });

    }

    return new FormGroup({
      sRequestID: new FormControl(_sRequestID),
      nInvoiceType: new FormControl(_nInvoiceType),
      nItemNo: new FormControl(_sItemNo),
      sOtherRefNoFIDocNo: new FormControl(_sOtherRefNoFIDocNo),
      sInvoiceNo: new FormControl({ value: !_sInvoiceNo ? null : _sInvoiceNo.startsWith('Blank_20') ? '-' : _sInvoiceNo, disabled: IsDisabledFormCustom }, Validators.required),
      sInvoiceNoDefault: new FormControl(_sInvoiceNoDefault),
      dInvoiceDate: new FormControl({ value: _dInvoiceDate, disabled: IsDisabledFormCustom }, Validators.required),
      sInvoiceDate: new FormControl(_sInvoiceDate),
      sVendorCode: new FormControl(_sVendorCode),
      sVendorName: new FormControl({ value: _sVendorName, disabled: IsDisabledFormCustom }, IsValidators),
      sVendorAddress: new FormControl({ value: _sVendorAddress, disabled: !IsVendorOneTime }, IsValidators),
      sInvoiceDesc: new FormControl({ value: _sInvoiceDesc, disabled: IsDisabledFormCustom }),
      sDescription: new FormControl(_sDescription),
      nExcludeVAT: new FormControl({ value: _sExcludeVAT, disabled: IsDisabledFormCustom }, Validators.required),
      sCurrency: new FormControl(_sCurrency),
      sVATType: new FormControl({ value: _sVATType, disabled: IsDisabledFormCustom }, Validators.required),
      sVATTypeOld: new FormControl(_sVATType),
      nVATRate: new FormControl(_nVATRate),
      nVAT: new FormControl({ value: _sVAT, disabled: !IsVAT }, Validators.required),
      nIncludeVAT: new FormControl(_sIncludeVAT),
      nWHTVal: new FormControl(_nWHTVal),
      OGnWHTVal: new FormControl(_nWHTVal),
      nWHTVal2: new FormControl(_nWHTVal2),
      OGnWHTVal2: new FormControl(_nWHTVal2),
      sWHTType: new FormControl({ value: _sWHTType, disabled: IsDisabledFormCustom }),
      sWHTType2: new FormControl(_sWHTType2),
      sWHTCode: new FormControl({ value: _sWHTCode, disabled: IsDisabledFormCustom }),
      OGsWHTCode: new FormControl({ value: _sWHTCode, disabled: IsDisabledFormCustom }),
      sWHTCode2: new FormControl(_sWHTCode2),
      OGsWHTCode2: new FormControl(_sWHTCode2),
      nWHTRate: new FormControl(_sWHTRate),
      nWHTRate2: new FormControl(_sWHTRate2),
      nWHTBase: new FormControl({ value: _nWHTBase, disabled: IsDisabledFormCustom }),
      OGnWHTBase: new FormControl({ value: _nWHTBase, disabled: IsDisabledFormCustom }),
      nWHTBase2: new FormControl(_nWHTBase2),
      OGnWHTBase2: new FormControl(_nWHTBase2),
      sTAXID: new FormControl({ value: _sTAXID, disabled: !IsVendorOneTime }, Validators.required),
      NoData: new FormControl(NoData),
      IsVAT: new FormControl(IsVAT),
      IsVendorOneTime: new FormControl(IsVendorOneTime),
      sCountryID: new FormControl(_sCountryID),
      sCountryName: new FormControl(_sCountryName),
      sProvCode: new FormControl(_sProvCode),
      sProvName: new FormControl(_sProvName),
      sAmpCode: new FormControl(_sAmpCode),
      sAmpName: new FormControl(_sAmpName),
      sTumbonCode: new FormControl(_sTumbonCode),
      sTumbonName: new FormControl(_sTumbonName),
      sPostCode: new FormControl(_sPostCode),
      sPhoneNumber: new FormControl(_sPhoneNumber),
      sFaxNumber: new FormControl(_sFaxNumber),
      sEmail: new FormControl(_sEmail),
      sVendorNamePayee: new FormControl(_sVendorNamePayee),
      sVendorAddressPayee: new FormControl(_sVendorAddressPayee),
      sTAXIDPayee: new FormControl(_sTAXIDPayee),
      nOfficeTypePayee: new FormControl(_nOfficeTypePayee),
      sVendorBranchPayee: new FormControl(_sVendorBranchPayee),
      sCountryIDPayee: new FormControl(_sCountryIDPayee),
      sCountryNamePayee: new FormControl(_sCountryNamePayee),
      sProvCodePayee: new FormControl(_sProvCodePayee), 
      sProvNamePayee: new FormControl(_sProvNamePayee),
      sAmpCodePayee: new FormControl(_sAmpCodePayee),
      sAmpNamePayee: new FormControl(_sAmpNamePayee),
      sTumbonCodePayee: new FormControl(_sTumbonCodePayee),
      sTumbonNamePayee: new FormControl(_sTumbonNamePayee),
      sPostCodePayee: new FormControl(_sPostCodePayee),
      sPhoneNumberPayee: new FormControl(_sPhoneNumberPayee),
      sFaxNumberPayee: new FormControl(_sFaxNumberPayee),
      sEmailPayee: new FormControl(_sEmailPayee),	
      sPaymentTypePayee: new FormControl(_sPaymentTypePayee),	
      sBankOtherPayee: new FormControl(_sBankOtherPayee),	
      sBankNamePayee: new FormControl(_sBankNamePayee),	
      sAccountNoPayee: new FormControl(_sAccountNoPayee),	
      sBankKeyPayee: new FormControl(_sBankKeyPayee),	
      sBankKeyNamePayee: new FormControl(_sBankKeyNamePayee),	
      sPaymentMethodNamePayee: new FormControl(_sPaymentMethodNamePayee),	
      sPaymentMethodPayee: new FormControl(_sPaymentMethodPayee + ''),	
      sReconAccount: new FormControl(_sReconAccount),
      IsIndividualPayee: new FormControl(_IsIndividualPayee),
      nOfficeType: new FormControl(_nOfficeType),
      sVendorBranch: new FormControl(_sVendorBranch),
      ListGL: _ArrGL,
      ListPstkey: _ArrPstkey,
      IsOpenPstKey: new FormControl(false),
    })
  }

  GenFlow() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sRequestID", this.sRequestID)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetFlow", httpOptions).toPromise().then(res => {
      if (res) {
        this.sHTMLFlow = res;
      }
      else {

      }
    });
  }

  async SetDataControl() {
    const httpOptions_VendorOT = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sComCode", this.InputFrom.controls["sCompCode"].value)
    };
    let VendorOT = await this.http.get<any>(this.System.SiteName + "api/_System/GetVendorOneTime", httpOptions_VendorOT).toPromise();
    if (VendorOT) {
      this.ArrVendorName = VendorOT;
    }

    this.IsLoadingBankAll = true;
    this.http.get(this.System.SiteName + "api/Autocomplete/Bank/1/All").toPromise().then((res: any) => {
      if (res) {
        this.DataBankBranch = res;
        this.IsLoadingBankAll = false;
      }
    })

    //Country
    await this.http.get<any>(this.System.SiteName + "api/_System/GetContry").toPromise().then(res => {
      if (res) {
        this._ArrCountry = res;
      }
    });

      //ProvCode
      await this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").toPromise().then(res => {
      if (res) {
        this._ArrProvince = res;
      }
    });

    //Bank
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sComCode", this.InputFrom.controls["sCompCode"].value)
        .set("cType", "1")
    };
    let GetBank = await this.http.get<any>(this.System.SiteName + "api/_System/GetBank", httpOptions).toPromise();
    if (GetBank) {
      this.ArrBank = GetBank;
    }

    let WHTType = await this.http.get<any>(this.System.SiteName + "api/AdminAdjust/WHTType", httpOptions).toPromise();
    if (WHTType) {
      this.ArrWHTType = WHTType;
    }

    let WHTCode = await this.http.get<any>(this.System.SiteName + "api/AdminAdjust/WHTCode").toPromise();
    if (WHTCode) {
      this.ArrWHTCode = WHTCode;
    }
    //GL
    const httpOptions_GL = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
    };
    let GL = await this.http.get<any>(this.System.SiteName + "api/_System/GetGL", httpOptions_GL).toPromise();
    if (GL) {
      this.ArrVendorGL = GL;
    }

    let VatPstKey = await this.http.get<any>(this.System.SiteName + "api/_System/GetVatPstKey", httpOptions_GL).toPromise();
    if (VatPstKey) {
      this.ArrVatPstKey = VatPstKey;
    }
    //CostCenter
    const httpOptions_CostCenter = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
    };
    let CostCenter = await this.http.get<any>(this.System.SiteName + "api/_System/GetCostCenter", httpOptions_CostCenter).toPromise();
    if (CostCenter) {
      this.ArrVendorCosCentor = CostCenter;
    }

    const httpOptions_IO = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
        .set("sCostCenter", "")
    };
    let IO = await this.http.get<any>(this.System.SiteName + "api/_System/GetIO2", httpOptions_IO).toPromise();
    if (IO) {
      this.ArrVendorIO = IO;
    }
    const httpOptions_ProfitCenter = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
        .set("sCostCenter", "")
    };
    let ProfitCenter = await this.http.get<any>(this.System.SiteName + "api/_System/GetProfitCenter", httpOptions_ProfitCenter).toPromise();
    if (ProfitCenter) {
      this.ArrVendorProfitCenter = ProfitCenter;
    }
    let VatType = await this.http.get<any>(this.System.SiteName + "api/_System/_GetVatType").toPromise();
    if (VatType) {
      VatType.push(
        {
          TAX_CODE: "Blank",
          DESCRIPTION: "NULL",
          nVAT: null,
          Desc: null,
          sReqType: "10,11,12,20,30,40,50,60,61,80"
        }
      )
      this.ArrVatType = VatType;
    }
    let Currency = await this.http.get<any>(this.System.SiteName + "api/_System/GetCurrency").toPromise();
    if (Currency) {
      this.ArrCurrency = Currency;
    }
    const httpOptionsBusinessArea = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls["sCompCode"].value)
    };
    let BusinessArea = await this.http.get<any>(this.System.SiteName + "api/_System/GetBusinessArea", httpOptionsBusinessArea).toPromise();
    if (BusinessArea) {
      this.ArrBusinessArea = BusinessArea;
    }
    let BusinessPlace = await this.http.get<any>(this.System.SiteName + "api/_System/GetBusinessPlace", httpOptionsBusinessArea).toPromise();
    if (BusinessPlace) {
      this.ArrBusinessPlace = BusinessPlace;
    }

    //Country
    let Country = await this.http.get<any>(this.System.SiteName + "api/_System/GetContry").toPromise();
    if (Country) {
      this._ArrCountry = Country;
    }

    await this.GET_PAYMENT_METHOD('');
  }

  async GET_PAYMENT_METHOD(addText) {
    const httpOptionsPAYMENT_METHOD = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls["sCompCode"].value)
        .set("sBankName", this.InputFrom.controls["sBankName" + addText].value)
        .set("sPaymentType", this.InputFrom.controls["sPaymentType" + addText].value)
    };
    let PAYMENT_METHOD = await this.http.get<any>(this.System.SiteName + "api/_System/GetPAYMENT_METHOD", httpOptionsPAYMENT_METHOD).toPromise();
    if (PAYMENT_METHOD) {
      this.ArrPAYMENT_METHOD = PAYMENT_METHOD;
    }
  }

  BindTable() {
    this.TR_NoData = this.ListInvoice.length != 0;
  }

  onInVoiceChange(value: Date, _inx) {
    if (value) {
      let FromArray = this.InputFrom.get('ListInvoice') as FormArray;
      FromArray.at(_inx).get("sInvoiceDate").setValue(this.System._ParseDateToFormat(value, ""));
    }
  }

  //#region Dropdown
  onchangebank(addText) {
    if (this.InputFrom.controls["sBankName" + addText].value == "Other, please specify") {
      this.InputFrom.controls["sBankOther" + addText].enable();
      this.InputFrom.controls["sBankOther" + addText].setValue(null);//Set ค่า
      this.InputFrom.controls["sBankOther" + addText].setValidators(Validators.required);//กำหนด Validate
      this.InputFrom.controls["sBankOther" + addText].setErrors(null);//ปรับ Control ให้เป็นปกติ
      this.InputFrom.controls["sBankOther" + addText].updateValueAndValidity();//Update Validate
      //this.InputFrom.controls["sBankOther"].markAsTouched({ onlySelf: true });//Update Validate
    }
    else {
      this.InputFrom.controls["sBankOther" + addText].setValue(null);//Set ค่า
      this.InputFrom.controls["sBankOther" + addText].setErrors(null);//ปรับ Control ให้เป็นปกติ
      this.InputFrom.controls["sBankOther" + addText].clearValidators();
      this.InputFrom.controls["sBankOther" + addText].markAsUntouched({ onlySelf: true });//Update Validate
      this.InputFrom.controls["sBankOther" + addText].disable();
    }

    this.PaymentMethodEvent(addText);
  }
  OnChangeVatItem(_Item, _inx) {
    let sVATType: string = _Item.controls["sVATType"].value;
    let nVat: any[] = this.ArrVatType.filter(w => w.TAX_CODE == sVATType);
    let nVATRate: any = null;
    if (nVat) {
      nVATRate = nVat[0].nVAT;
    }
    _Item.controls["nVATRate"].setValue(nVATRate);

    if (nVATRate) {
      _Item.controls["nVAT"].setErrors(null);//ปรับ Control ให้เป็นปกติ
      _Item.controls["nVAT"].markAsUntouched({ onlySelf: true });
      _Item.controls["nVAT"].enable();
      _Item.controls["ListGL"].controls.forEach(function (_ItemSub) {
        _ItemSub.controls["nVAT"].enable();
        _ItemSub.controls["nVAT"].setValidators(Validators.required);//กำหนด Validate
        _ItemSub.controls["nVAT"].setErrors(null);//ปรับ Control ให้เป็นปกติ
        _ItemSub.controls["nVAT"].updateValueAndValidity();//Update Validate
      });
    }
    else {
      _Item.controls["nVAT"].setErrors(null);//ปรับ Control ให้เป็นปกติ
      _Item.controls["nVAT"].markAsUntouched({ onlySelf: true });
      _Item.controls["nVAT"].disable();
      _Item.controls["ListGL"].controls.forEach(function (_ItemSub) {
        _ItemSub.controls["nVAT"].disable();
        _ItemSub.controls["nVAT"].markAsUntouched({ onlySelf: true });
        _ItemSub.controls["nVAT"].setValue(null);
        _ItemSub.controls["nVAT"].setErrors(null);
        _ItemSub.controls["nVAT"].clearValidators();
      });
    }

    this.CalculateITEM(_Item, _inx);
  }
  async PaymentMethodEvent(addText) {
    this.ArrPAYMENT_METHOD = [];
    await this.GET_PAYMENT_METHOD(addText);

    if (this.ArrPAYMENT_METHOD.length == 1) {
      if (addText === 'Payee') {
        this.InputFrom.patchValue({
          sPaymentMethodNamePayee: this.ArrPAYMENT_METHOD[0].PAY_METHOD_DESC,
          sPaymentMethodPayee: this.ArrPAYMENT_METHOD[0].PAY_METHOD + '',
        })
      }
      else {
        this.InputFrom.patchValue({
          sPaymentMethodName: this.ArrPAYMENT_METHOD[0].PAY_METHOD_DESC,
          sPaymentMethod: this.ArrPAYMENT_METHOD[0].PAY_METHOD,
        })
      }
    }
    else {
      if (addText === 'Payee') {
        this.InputFrom.patchValue({
          sPaymentMethodNamePayee: "",
          sPaymentMethodPayee: ""
        })
      }
      else {
        this.InputFrom.patchValue({
          sPaymentMethodName: "",
          sPaymentMethod: ""
        })
      }
    }
  }
  //#endregion

  //#region Event CheckBox
  cbPaymentType(nType, sBankName, sMode, addText) {
    let sValueBank = sBankName != "" ? sBankName : this.InputFrom.controls["sBankName"].value;
    if (sMode == "F") {//ถ้าเป็นการกดมาจากหน้าบ้านจะทำ Event นี้
      this.PaymentMethodEvent(addText);
    }
    var GetMethod = this.ArrPAYMENT_METHOD;
    let data = {
      sPaymentMethod: GetMethod.length == 1 ? GetMethod[0].PAY_METHOD + '' : '',
      sPaymentMethodName: GetMethod.length == 1 ? GetMethod[0].PAY_METHOD_DESC : ''
    }

    switch (nType) {
      case 1:
        //var GetMethod = this.ArrPAYMENT_METHOD.filter(w => w.PAY_METHOD == 0);
        
        if(addText === 'Payee'){
          this.InputFrom.patchValue({
            sBankKeyPayee: "",
            sBankKeyNamePayee: "",
            sAccountNoPayee: "",
            sBankNamePayee: "",
            sBankOtherPayee: "",
          });
        }
        else {
          this.InputFrom.patchValue({
            sBankName: "",
            sBankOther: "",
            sAccountNo: "",
          });
        }
        if (addText === 'Payee') {
          this.InputFrom.patchValue({
            sPaymentMethodNamePayee: GetMethod.length == 1 ? GetMethod[0].PAY_METHOD_DESC : "",
            sPaymentMethodPayee: GetMethod.length == 1 ? GetMethod[0].PAY_METHOD + "" : ""
          });

          this.InputFrom.controls["sBankKey" + addText].disable();
          this.InputFrom.controls["sBankKeyName" + addText].disable();
          this.InputFrom.controls["sBankKey" + addText].setErrors(null);//ปรับ Control ให้เป็นปกติ
          this.InputFrom.controls["sBankKey" + addText].markAsUntouched({ onlySelf: true });//Update Validate
          this.InputFrom.controls["sBankKeyName" + addText].setErrors(null);//ปรับ Control ให้เป็นปกติ
          this.InputFrom.controls["sBankKeyName" + addText].markAsUntouched({ onlySelf: true });//Update Validate
        }
        else {
          this.InputFrom.patchValue({
            sPaymentMethodName: GetMethod.length == 1 ? GetMethod[0].PAY_METHOD_DESC : "",
            sPaymentMethod: GetMethod.length == 1 ? GetMethod[0].PAY_METHOD + "" : ""
          });
        }
       
        this.InputFrom.controls["sBankName" + addText].disable();
        this.InputFrom.controls["sBankOther" + addText].disable();
        this.InputFrom.controls["sAccountNo" + addText].disable();

        
        this.InputFrom.controls["sBankName" + addText].setErrors(null);//ปรับ Control ให้เป็นปกติ
        this.InputFrom.controls["sBankName" + addText].markAsUntouched({ onlySelf: true });//Update Validate
        this.InputFrom.controls["sAccountNo" + addText].setErrors(null);//ปรับ Control ให้เป็นปกติ
        this.InputFrom.controls["sAccountNo" + addText].markAsUntouched({ onlySelf: true });//Update Validate
        this.InputFrom.controls["sBankOther" + addText].clearValidators();
        this.InputFrom.controls["sBankOther" + addText].markAsUntouched({ onlySelf: true });//Update Validate
        break;
      case 2:
        //var GetMethod = this.ArrPAYMENT_METHOD.filter(w => w.PAY_METHOD == 5);
     

        if (addText === 'Payee') {
          this.InputFrom.patchValue({
            sPaymentMethodNamePayee: GetMethod.length == 1 ? GetMethod[0].PAY_METHOD_DESC : "",
            sPaymentMethodPayee: GetMethod.length == 1 ? GetMethod[0].PAY_METHOD + "" : ""
          });
        }
        else {
          this.InputFrom.patchValue({
            sPaymentMethodName: GetMethod.length == 1 ? GetMethod[0].PAY_METHOD_DESC : "",
            sPaymentMethod: GetMethod.length == 1 ? GetMethod[0].PAY_METHOD + "" : ""
          });
        }


        if (this.PRMS) {
          this.InputFrom.controls["sBankName" + addText].enable();
          this.InputFrom.controls["sAccountNo" + addText].enable();
        }

        this.InputFrom.controls["sBankOther" + addText].markAsTouched({ onlySelf: true });//Update Validate
        this.InputFrom.controls["sBankOther" + addText].disable();

        if (sValueBank == "Other, please specify") {
          if (this.PRMS) {
            this.InputFrom.controls["sBankOther" + addText].enable();
            this.InputFrom.controls["sBankOther" + addText].setValue(null);//Set ค่า
            this.InputFrom.controls["sBankOther" + addText].setValidators(Validators.required);//กำหนด Validate
            this.InputFrom.controls["sBankOther" + addText].setErrors(null);//ปรับ Control ให้เป็นปกติ
            this.InputFrom.controls["sBankOther" + addText].updateValueAndValidity();//Update Validate
          }
          else {
            this.InputFrom.controls["sBankOther" + addText].setErrors(null);//ปรับ Control ให้เป็นปกติ
            this.InputFrom.controls["sBankOther" + addText].markAsUntouched({ onlySelf: false });//Update Validate
          }

        }
        else {

          this.InputFrom.controls["sBankOther" + addText].setValue(null);//Set ค่า
          this.InputFrom.controls["sBankOther" + addText].setErrors(null);//ปรับ Control ให้เป็นปกติ
          this.InputFrom.controls["sBankOther" + addText].clearValidators();
          this.InputFrom.controls["sBankOther" + addText].markAsUntouched({ onlySelf: true });//Update Validate

          if (addText === 'Payee') {
            this.InputFrom.controls["sBankKey" + addText].enable();
            this.InputFrom.controls["sBankKey" + addText].setValue(null);//Set ค่า
            this.InputFrom.controls["sBankKey" + addText].setErrors(null);//ปรับ Control ให้เป็นปกติ
            this.InputFrom.controls["sBankKey" + addText].clearValidators();
            this.InputFrom.controls["sBankKey" + addText].markAsUntouched({ onlySelf: true });//Update Validate
            
            this.InputFrom.controls["sBankKeyName" + addText].enable();
            this.InputFrom.controls["sBankKeyName" + addText].setValue(null);//Set ค่า
            this.InputFrom.controls["sBankKeyName" + addText].setErrors(null);//ปรับ Control ให้เป็นปกติ
            this.InputFrom.controls["sBankKeyName" + addText].clearValidators();
            this.InputFrom.controls["sBankKeyName" + addText].markAsUntouched({ onlySelf: true });//Update Validate
          }

          this.InputFrom.controls["sBankName" + addText].setValue(null);//Set ค่า
          this.InputFrom.controls["sBankName" + addText].setErrors(null);//ปรับ Control ให้เป็นปกติ
          this.InputFrom.controls["sBankName" + addText].clearValidators();
          this.InputFrom.controls["sBankName" + addText].markAsUntouched({ onlySelf: true });//Update Validate

          this.InputFrom.controls["sAccountNo" + addText].setValue(null);//Set ค่า
          this.InputFrom.controls["sAccountNo" + addText].setErrors(null);//ปรับ Control ให้เป็นปกติ
          this.InputFrom.controls["sAccountNo" + addText].clearValidators();
          this.InputFrom.controls["sAccountNo" + addText].markAsUntouched({ onlySelf: true });//Update Validate
        }
        break;
    }

  
    return data
  }
  //#endregion

  //#region Event AutoComplete
  OnBlurGCI(event: TypeaheadMatch, _Item_Sub, _inx, _sType) {
    let FromArray = this.InputFrom.get('ArrGL') as FormArray;
    let Pass: boolean = true;
    try {
      switch (_sType) {
        case "G":
          if (!event.item.GL_ACCOUNT_NO) {
            Pass = false;
          }
          break;
        case "C":
          if (!event.item.COST_CENTER) {
            Pass = false;
          }
          break;
        case "I":
          if (!event.item.ORDER_NUMBER) {
            Pass = false;
          }
          break;
        case "P":
          if (!event.item.sProfitCenterNo) {
            Pass = false;
          }
          break;
      }
    }
    catch (ex) {//กรณีที่พังจะ Reset ค่าทิ้ง
      Pass = false;
    }
    if (Pass) {

    }
    else {
      switch (_sType) {
        case "G":
          _Item_Sub.patchValue({ sGL: "" });
          break;
        case "C":
          _Item_Sub.patchValue({ sCCTR: "" });
          break;
        case "I":
          _Item_Sub.patchValue({ sIO: "" });
          break;
        case "P":
          _Item_Sub.patchValue({ sPTC: "" });
          break;
      }
    }
  }
  OnSelectGCI(event: TypeaheadMatch, _Item, _inx, _sType) {
    let FromArray = _Item.controls["ListGL"] as FormArray;
    let sGL = (FromArray.at(_inx).get("sGL").value != null) ? FromArray.at(_inx).get("sGL").value : "";
    let sCostCenter = (FromArray.at(_inx).get("sCCTR").value != null) ? FromArray.at(_inx).get("sCCTR").value : "";
    let sIO = (FromArray.at(_inx).get("sIO").value != null) ? FromArray.at(_inx).get("sIO").value : "";
    let sProfitCenter = (FromArray.at(_inx).get("sPTC").value != null) ? FromArray.at(_inx).get("sPTC").value : "";

    let SP_GL = sGL.split('-');
    let SP_CCTR = sCostCenter.split('-');
    let SP_IO = sIO.split('-');
    let SP_PTC = sProfitCenter.split('-');

    let SE_GL = SP_GL.length > 1 ? (SP_GL[0] + "").trim() : sGL;
    let SE_CCTR = SP_CCTR.length > 1 ? (SP_CCTR[0] + "").trim() : sCostCenter;
    let SE_IO = SP_IO.length > 1 ? (SP_IO[0] + "").trim() : sIO;
    let SE_PTC = SP_PTC.length > 1 ? (SP_PTC[0] + "").trim() : sProfitCenter;

    let _CHK = this.OnChange_CheckDuplicateGCI(SE_GL, SE_CCTR, SE_IO, SE_PTC, FromArray, _inx);
    //let _CHK = this.OnChange_CheckDuplicateGCI(sGL, sCostCenter, sIO, FromArray, _inx);
    let nReqType = this.InputFrom.controls["nReqType"].value;
    if (!_CHK.IsPass && nReqType != 80) {
      switch (_sType) {
        case "G":
          FromArray.at(_inx).patchValue({ sGL: "" });
          break;
        case "C":
          FromArray.at(_inx).patchValue({ sCCTR: "" });
          break;
        case "I":
          FromArray.at(_inx).patchValue({ sIO: "" });
          break;
        case "P":
          FromArray.at(_inx).patchValue({ sPTC: "" });
          break;
      }
      this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, _CHK.Msg, function () { Swal.close(); });
    }
    else {
      switch (_sType) {
        case "G":
          FromArray.at(_inx).patchValue({ sGL: event.item.GL_ACCOUNT_NO });
          break;
        case "C":
          FromArray.at(_inx).patchValue({ sCCTR: event.item.COST_CENTER });
          break;
        case "I":
          FromArray.at(_inx).patchValue({ sIO: event.item.ORDER_NUMBER });
          break;
        case "P":
          FromArray.at(_inx).patchValue({ sPTC: event.item.sProfitCenterNo });
          break;
      }
    }
    let ListPstkey = _Item.controls["ListPstkey"] as FormArray;
    ListPstkey.clear();
  }
  OnChange_CheckDuplicateGCI(sGL, sCCTR, sIO, sPTC, FromArray, _inx) {
    let Result = { IsPass: true, Msg: "" };
    //Case 1 เช็คจาก Array Invoice
    for (var i = 0; i < FromArray.length; i++) {
      if (i != _inx) {//ตรวจสอบ Index ว่าต้องไม่เป็น Index กับตัวที่ Select
        let Isdelete = FromArray.value[i].cActive == "N";
        let _sGL = FromArray.value[i].sGL;
        let _sCostCenter = FromArray.value[i].sCCTR;
        let _sIO = FromArray.value[i].sIO;
        let _sPTC = FromArray.value[i].sPTC;
        if (!Isdelete) {
          if (this.IsNotFill_IO) {//IsNotFill_IO คือระบบไม่ต้องกรอก IO
            if (!this.System._IsNullOrEmpty(sGL) && !this.System._IsNullOrEmpty(sCCTR)) {//เช็คแค่ GL,CostCenter
              if (sGL == _sGL && sCCTR == _sCostCenter) {
                Result.IsPass = false;
                Result.Msg = this.swal.BoxMsg.Desc_Invoice_GCI;
                return Result;
              }
            }
          }
          else {
            //เช็คแค่ GL,CostCenter,ProfitCenter
            if (!this.System._IsNullOrEmpty(sGL) && !this.System._IsNullOrEmpty(sCCTR) && !this.System._IsNullOrEmpty(sIO) && !this.System._IsNullOrEmpty(sPTC)) {
              if (sGL == _sGL && sCCTR == _sCostCenter && sIO == _sIO && sPTC == _sPTC) { //เช็คแค่ GL,CostCenter , IO, ProfitCenter
                Result.IsPass = false;
                Result.Msg = this.swal.BoxMsg.Desc_Invoice_GCI;
                return Result;
              }
            }
          }
        }
      }
    }

    return Result;
  }
  //PaymentMethod
  OnSelecPaymentMethod(event: TypeaheadMatch, addText): void {
    let _Form = this.InputFrom;
    if (addText === 'Payee') {
      _Form.patchValue({
        sPaymentMethodPayee: event.item.PAY_METHOD + '',
      })
    }
    else {
      _Form.patchValue({
        sPaymentMethod: event.item.PAY_METHOD,
      })
    }
  }
  OnBlurPaymentMethod(event: TypeaheadMatch, addText): void {
    let _Form = this.InputFrom;
    let Pass: boolean = true;
    try {
      if (!event.item.PAY_METHOD) {
        Pass = false;
      }
    }
    catch (ex) {//กรณีที่พังจะ Reset ค่าทิ้ง
      Pass = false;
    }
    if (Pass) {

    }
    else {
      if (addText === 'Payee') {
        _Form.patchValue({
          sPaymentMethodNamePayee: null,
          sApsPaymentMethodprove1: null
        });
      }
      else {
        _Form.patchValue({
          sPaymentMethodName: null,
          sApsPaymentMethodprove1: null
        });
      }
    }
  }

  //Country
  OnChangeCountry(event: TypeaheadMatch) {
    let sCountry = event.item.sCountryID;
    if (sCountry == "213") {
      this.GetProvince();

      this.InputFrom.patchValue({
        sCountryID: sCountry,
        sProvCode: null,
        sProvName: null,
        sAmpCode: null,
        sAmpName: null,
        sTumbonCode: null,
        sTumbonName: null,
        sPostCode: null
      });

      this._ArrAmphur = [];
      this._ArrTumbon = [];
    }
    else {
      this.InputFrom.patchValue({
        sCountryID: sCountry,
        sProvCode: null,
        sProvName: null,
        sAmpCode: null,
        sAmpName: null,
        sTumbonCode: null,
        sTumbonName: null,
        sPostCode: null
      });
      this._ArrProvince = [];
      this._ArrAmphur = [];
      this._ArrTumbon = [];
    }
  }
  OnBlurCheckCountry(event: TypeaheadMatch): void {
    let CHK = this._ArrCountry.filter(f => f.sCountryName == this.InputFrom.controls["sCountryName"].value);
    if (CHK.length > 0) {
      this._ArrProvince = [];
      if (CHK[0].sCountryID + "" == "213") {
        this.GetProvince();
      }
      else {
        this.InputFrom.patchValue({
          sCountryID: CHK[0].sCountryID + "",
          sCountryName: CHK[0].sCountryName + "",
          sProvCode: null,
          sProvName: null,
          sAmpCode: null,
          sAmpName: null,
          sTumbonCode: null,
          sTumbonName: null
        });
        this._ArrAmphur = [];
        this._ArrTumbon = [];
      }
    }
    else {
      this.InputFrom.patchValue({
        sCountryID: null,
        sCountryName: null,
        sProvCode: null,
        sProvName: null,
        sAmpCode: null,
        sAmpName: null,
        sTumbonCode: null,
        sTumbonName: null
      });
      this._ArrProvince = [];
      this._ArrAmphur = [];
      this._ArrTumbon = [];
    }
  }
  OnChangeRecon(event: TypeaheadMatch) {
    let sReconAccount = event.item.sReconAccount;
    this.InputFrom.patchValue({
      sReconAccount: sReconAccount,
    });
    
  }
  OnBlurCheckRecon(event: TypeaheadMatch): void {
    let CHK = this.ArrRecon.filter(f => f.sReconAccount == this.InputFrom.controls["sReconAccount"].value);
    if (CHK.length > 0) {
      this.InputFrom.patchValue({
        sReconAccount: CHK[0].sReconAccount + "",
      });
    }
    else {
      this.InputFrom.patchValue({
        sReconAccount: null,
      });
      this._ArrProvince = [];
    }
  }
  hidBranch() {
    this.hBranch = this.InputFrom.value.nOfficeTypePayee === 1;
    if (this.hBranch == false) {
      var code = this.InputFrom.get('sVendorBranchPayee').value;
      if (code === '') code = '00000'
      this.InputFrom.controls['sVendorBranchPayee'].enable();
      this.InputFrom.patchValue({ sVendorBranchPayee: code })
    
    } else {
      this.InputFrom.controls['sVendorBranchPayee'].disable();
      this.InputFrom.patchValue({ sVendorBranchPayee: '' })

    }
  }
  GetProvince() {
    this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").subscribe(res => {
      if (res) {
        this._ArrProvince = res;
      }
    })
  }
  OnChangeProvCode(event: TypeaheadMatch, Case) {
    this.InputFrom.patchValue({ sProvCode: event.item.sProvCode, sAmpCode: "", sAmpName: "", sTumbonCode: "", sTumbonName: "" });
    this.GetAmphor();
  }
  GetAmphor() {
    const httpOptions_Amphur = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams().set("sProvCode", this.InputFrom.controls["sProvCode"].value)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).subscribe(res => {
      if (res) {
        this._ArrAmphur = res;
      }
    });
  }
  OnChangeAmpCode(event: TypeaheadMatch) {
    this.InputFrom.patchValue({ sAmpCode: event.item.sAmpCode, sTumbonCode: "", sTumbonName: "" });
    this.GetTumbon();
  }
  GetTumbon() {
    const httpOptions_Tumbon = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sAmpCode", this.InputFrom.controls["sAmpCode"].value)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).subscribe(res => {
      if (res) {
        this._ArrTumbon = res;
      }
    });
  }
  GetRecon(sRequestID, sVendorCode) {
    const httpOptions_Recon = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sRequestID", sRequestID)
        .set("sVendorCode", sVendorCode)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetRecon/", httpOptions_Recon).subscribe(res => {
      if (res) {
        this.ArrRecon = res;
      }
    });
  }
  OnChangeTumbon(event: TypeaheadMatch) {
    this.InputFrom.patchValue({ sTumbonCode: event.item.sTumbonCode });
  }
  OnBlurCheckTH(event: TypeaheadMatch, Case) {
    let ISTH = this.InputFrom.controls["sCountryID"].value == "213";
    if (ISTH)
      switch (Case) {
        case "sProvName":
          if (!event.item.sProvCode) {
            this.InputFrom.patchValue({ sProvCode2: "", sProvName2: "", sAmpCode2: "", sAmpName2: "", sTumbonCode2: "", sTumbonName2: "" });
          }
          break;
        case "sAmpName":
          if (!event.item.sAmpCode) {
            this.InputFrom.patchValue({ sAmpCode2: "", sAmpName2: "", sTumbonCode2: "", sTumbonName2: "" });
          }
          break;
        case "sTumbonName":
          if (!event.item.sTumbonCode) {
            this.InputFrom.patchValue({ sTumbonCode2: "", sTumbonName2: "" });
          }
          break;
      }
  }
  //#endregion

  //#region Event Tag a
  OpenVendor(template: TemplateRef<any>, Item) {
    this.sModalDetail = Item.controls.sVendorName.value;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }
  OpenVendorAddress(template: TemplateRef<any>, Item) {
    this.sModalDetail = Item.controls.sVendorAddress.value;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }
  OpenDescription(template: TemplateRef<any>, Item) {
    this.sModalDetail = Item.controls.sDescription.value;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }
  OpenComment(template: TemplateRef<any>, Item) {
    this.sModalDetail = Item.sComment;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }
  OpenInvoiceDesc(template: TemplateRef<any>, Item) {
    //this.sModalDetail = Item.controls.sInvoiceDesc.value;
    this.sModalDetail = Item.controls.sDescription.value;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }

  OpenRecon(template: TemplateRef<any>, _Item, _inx) {
    this.EditInx = _inx;

    let ListInvoice = this.InputFrom.controls["ListInvoice"] as FormArray;
    let FromInvoice = ListInvoice.at(_inx) as FormGroup;

    this.sInvoiceNo = FromInvoice.controls["sInvoiceNo"].value;
    this.InputFrom.patchValue({
      sVendorNamePayee: FromInvoice.controls["sVendorNamePayee"].value,
      sVendorAddressPayee: FromInvoice.controls["sVendorAddressPayee"].value,
      sCountryIDPayee: FromInvoice.controls["sCountryIDPayee"].value,
      sCountryNamePayee: FromInvoice.controls["sCountryNamePayee"].value,
      sProvCodePayee: FromInvoice.controls["sProvCodePayee"].value,
      sProvNamePayee: FromInvoice.controls["sProvNamePayee"].value,
      sAmpCodePayee: FromInvoice.controls["sAmpCodePayee"].value,
      sAmpNamePayee: FromInvoice.controls["sAmpNamePayee"].value,
      sTumbonCodePayee: FromInvoice.controls["sTumbonCodePayee"].value,
      sTumbonNamePayee: FromInvoice.controls["sTumbonNamePayee"].value,
      sPostCodePayee: FromInvoice.controls["sPostCodePayee"].value,
      sPhoneNumberPayee: FromInvoice.controls["sPhoneNumberPayee"].value,
      sFaxNumberPayee: FromInvoice.controls["sFaxNumberPayee"].value,
      sEmailPayee: FromInvoice.controls["sEmailPayee"].value,
      sTAXIDPayee: FromInvoice.controls["sTAXIDPayee"].value,
      sReconAccount: FromInvoice.controls["sReconAccount"].value,
      IsIndividualPayee: FromInvoice.controls["IsIndividualPayee"].value,
      nOfficeTypePayee: FromInvoice.controls["nOfficeTypePayee"].value,
      sPaymentTypePayee:FromInvoice.controls["sPaymentTypePayee"].value,
      sBankOtherPayee: FromInvoice.controls["sBankOtherPayee"].value,
      sBankNamePayee: FromInvoice.controls["sBankNamePayee"].value,
      sBankKeyPayee: FromInvoice.controls["sBankKeyPayee"].value,
      sBankKeyNamePayee: FromInvoice.controls["sBankKeyNamePayee"].value,
      sAccountNoPayee: FromInvoice.controls["sAccountNoPayee"].value,
      sPaymentMethodNamePayee: FromInvoice.controls["sPaymentMethodNamePayee"].value,
      sPaymentMethodPayee: FromInvoice.controls["sPaymentMethodPayee"].value + '',
    });
    
    this.PaymentMethodEvent('Payee');

    this.hBranch = FromInvoice.controls["nOfficeTypePayee"].value === 1;
    if (this.hBranch == false) {
      var code = FromInvoice.controls["sVendorBranchPayee"].value;
      if (code === '') code = '00000'
      this.InputFrom.controls['sVendorBranchPayee'].enable();
      this.InputFrom.patchValue({ sVendorBranchPayee: code })
    } else {
      this.InputFrom.controls['sVendorBranchPayee'].disable();
      this.InputFrom.patchValue({ sVendorBranchPayee: "" })
    }

    if (this.InputFrom.value.sPaymentTypePayee === 1) {
      this.InputFrom.controls["sBankKeyPayee"].disable();
      this.InputFrom.controls["sBankKeyNamePayee"].disable();
      this.InputFrom.controls["sBankNamePayee"].disable();
      this.InputFrom.controls["sBankOtherPayee"].disable();
      this.InputFrom.controls["sAccountNoPayee"].disable();

      this.InputFrom.controls["sBankKeyPayee"].setErrors(null);//ปรับ Control ให้เป็นปกติ
      this.InputFrom.controls["sBankKeyPayee"].markAsUntouched({ onlySelf: true });//Update Validate
      this.InputFrom.controls["sBankKeyNamePayee"].setErrors(null);//ปรับ Control ให้เป็นปกติ
      this.InputFrom.controls["sBankKeyNamePayee"].markAsUntouched({ onlySelf: true });//Update Validate
      this.InputFrom.controls["sBankNamePayee"].setErrors(null);//ปรับ Control ให้เป็นปกติ
      this.InputFrom.controls["sBankNamePayee"].markAsUntouched({ onlySelf: true });//Update Validate
      this.InputFrom.controls["sAccountNoPayee"].setErrors(null);//ปรับ Control ให้เป็นปกติ
      this.InputFrom.controls["sAccountNoPayee"].markAsUntouched({ onlySelf: true });//Update Validate
      this.InputFrom.controls["sBankOtherPayee"].clearValidators();
      this.InputFrom.controls["sBankOtherPayee"].markAsUntouched({ onlySelf: true });//Update Validate
    }

    this.GetRecon(this.sRequestID, FromInvoice.controls["sVendorCode"].value);
    
    // if (FromInvoice.controls["sCountryID"].value == "213") {
    //   this.GetProvince();
    //   this.GetAmphor();
    //   this.GetTumbon();
    // }

    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }

  UpdateRecon() {
    let Pass = true;
    let This = this;

    if(this.InputFrom.value.IsIndividualPayee) {
    let Field = ['sVendorNamePayee', 'sVendorAddressPayee', 'sCountryNamePayee', 'sProvNamePayee', 'sAmpNamePayee', 'sTumbonNamePayee'];
    if (this.InputFrom.value.sPaymentTypePayee === '2'){
      Field.push('sBankKeyNamePayee');
      Field.push('sAccountNoPayee');
      Field.push('sBankNamePayee');
    }
    
    Field.forEach(function (Item) {
      if (!This.InputFrom.get(Item).valid) {
        This.InputFrom.get(Item).markAsTouched({ onlySelf: true });
        Pass = false;
      }
    });
    }

    if (Pass) {
      let ListInvoice = this.InputFrom.controls["ListInvoice"] as FormArray;
      let FromInvoice = ListInvoice.at(this.EditInx) as FormGroup;

      FromInvoice.controls["sVendorNamePayee"].setValue(this.InputFrom.controls["sVendorNamePayee"].value);
      FromInvoice.controls["sVendorAddressPayee"].setValue(this.InputFrom.controls["sVendorAddressPayee"].value);
      FromInvoice.controls["sTAXIDPayee"].setValue(this.InputFrom.controls["sTAXIDPayee"].value);
      FromInvoice.controls["nOfficeTypePayee"].setValue(this.InputFrom.controls["nOfficeTypePayee"].value);
      FromInvoice.controls["sVendorBranchPayee"].setValue(this.InputFrom.controls["sVendorBranchPayee"].value);
      FromInvoice.controls["sCountryIDPayee"].setValue(this.InputFrom.controls["sCountryIDPayee"].value);
      FromInvoice.controls["sCountryNamePayee"].setValue(this.InputFrom.controls["sCountryNamePayee"].value);
      FromInvoice.controls["sProvCodePayee"].setValue(this.InputFrom.controls["sProvCodePayee"].value);
      FromInvoice.controls["sProvNamePayee"].setValue(this.InputFrom.controls["sProvNamePayee"].value);
      FromInvoice.controls["sAmpCodePayee"].setValue(this.InputFrom.controls["sAmpCodePayee"].value);
      FromInvoice.controls["sAmpNamePayee"].setValue(this.InputFrom.controls["sAmpNamePayee"].value);
      FromInvoice.controls["sTumbonCodePayee"].setValue(this.InputFrom.controls["sTumbonCodePayee"].value);
      FromInvoice.controls["sTumbonNamePayee"].setValue(this.InputFrom.controls["sTumbonNamePayee"].value);
      FromInvoice.controls["sPostCodePayee"].setValue(this.InputFrom.controls["sPostCodePayee"].value);
      FromInvoice.controls["sPhoneNumberPayee"].setValue(this.InputFrom.controls["sPhoneNumberPayee"].value);
      FromInvoice.controls["sFaxNumberPayee"].setValue(this.InputFrom.controls["sFaxNumberPayee"].value);
      FromInvoice.controls["sEmailPayee"].setValue(this.InputFrom.controls["sEmailPayee"].value);
      FromInvoice.controls["sPaymentTypePayee"].setValue(this.InputFrom.controls["sPaymentTypePayee"].value);
      FromInvoice.controls["sBankOtherPayee"].setValue(this.InputFrom.controls["sBankOtherPayee"].value);
      FromInvoice.controls["sBankNamePayee"].setValue(this.InputFrom.controls["sBankNamePayee"].value);
      FromInvoice.controls["sAccountNoPayee"].setValue(this.InputFrom.controls["sAccountNoPayee"].value);
      FromInvoice.controls["sBankKeyPayee"].setValue(this.InputFrom.controls["sBankKeyPayee"].value);
      FromInvoice.controls["sBankKeyNamePayee"].setValue(this.InputFrom.controls["sBankKeyNamePayee"].value);
      FromInvoice.controls["sPaymentMethodNamePayee"].setValue(this.InputFrom.controls["sPaymentMethodNamePayee"].value);
      FromInvoice.controls["sPaymentMethodPayee"].setValue(this.InputFrom.controls["sPaymentMethodPayee"].value + '');
      FromInvoice.controls["sReconAccount"].setValue(this.InputFrom.controls["sReconAccount"].value);
      FromInvoice.controls["IsIndividualPayee"].setValue(this.InputFrom.controls["IsIndividualPayee"].value);

  


      this.EditInx = null;
      this.modalRef.hide();
    }
    
  }


  ArrEdtItemText = [];
  EdtItemInx: number = 0;
  EdtItemNo: string = "";
  EdtItemText: string = "";
  EditAllItemText(templeteEditAllItemText: TemplateRef<any>, Item, _inx) {
    let This = this;
    let ListInvoice = this.InputFrom.controls["ListInvoice"] as FormArray;
    let FromInvoice = ListInvoice.at(_inx) as FormGroup;

    this.EdtItemInx = _inx;
    //this.EdtItemText = FromInvoice.controls["sInvoiceDesc"].value;
    this.EdtItemText = FromInvoice.controls["sDescription"].value;
    this.EdtItemNo = FromInvoice.controls["nItemNo"].value;
    let EDT_ITEM = this.ArrEdtItemText.filter(w => w.nItemNo == this.EdtItemNo);
    if (EDT_ITEM.length > 0) {
      This.EdtItemText = EDT_ITEM[0].sText;
    }
    this.modalRef = this.modalService.show(
      templeteEditAllItemText,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }
  UpdateItemText() {
    let This = this;
    this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Confirm, this.swal.BoxMsg.Desc_Confirm_Save, function () {
      This.System.BlockUI();
      let ListInvoice = This.InputFrom.controls["ListInvoice"] as FormArray;
      let FromInvoice = ListInvoice.at(This.EdtItemInx) as FormGroup;
      let nItemNo = FromInvoice.controls["nItemNo"].value;

      let EDT_ITEM = This.ArrEdtItemText.filter(w => w.nItemNo == nItemNo);
      if (EDT_ITEM.length > 0) {
        EDT_ITEM[0].sText = This.EdtItemText;
      } else {
        This.ArrEdtItemText.push({ nItemNo: nItemNo, sText: This.EdtItemText });
      }

      let ListGL = FromInvoice.controls["ListGL"] as FormArray;
      ListGL.controls.forEach(function (_Item) {
        let FromGroup_GL = _Item as FormGroup;
        FromGroup_GL.controls["sText"].setValue(This.EdtItemText);
      });

      let ListPstkey = FromInvoice.controls["ListPstkey"] as FormArray;
      if (ListPstkey.length > 0) {
        ListPstkey.controls.forEach(function (_Item) {
          let FromGroup_PST = _Item as FormGroup;
          FromGroup_PST.controls["sText"].setValue(This.EdtItemText);
        });
      }
      else {
        let PST_DATA = This.ArrPstKey.filter(w => w.sRequestID == This.sRequestID && w.nItemNo == nItemNo && w.IsDelete == false);
        PST_DATA.forEach(function (_Item) {
          _Item.sText = This.EdtItemText
        });
      }
      This.System.UnBlockUI();

      This.modalRef.hide();
      This.EdtItemText = "";
      This.EdtItemNo = "";
      Swal.close();
    }, function () {
      Swal.close();
    });
  }
  //#endregion

  //#region Event
  SaveDraft(_Item, _inx) {
    let _this = this;
    let IsPass = false;
    IsPass = this.CheckDraftValidate(_inx);
    if (IsPass) {
      this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Confirm, this.swal.BoxMsg.Desc_Confirm_Save, function () {
        _this.System.BlockUI();
        let _Data = {
          sRequestID: _this.sRequestID,
          nItemNo: _Item.controls['nItemNo'].value,
          sVendorName: _Item.controls['sVendorName'].value,
          sVendorAddress: _Item.controls['sVendorAddress'].value,
          sCountryID: _Item.controls['sCountryID'].value,
          sProvCode: _Item.controls['sProvCode'].value,
          sProvName: _Item.controls['sProvName'].value,
          sAmpCode: _Item.controls['sAmpCode'].value,
          sAmpName: _Item.controls['sAmpName'].value,
          sTumbonCode: _Item.controls['sTumbonCode'].value,
          sTumbonName: _Item.controls['sTumbonName'].value,
          sPostCode: _Item.controls['sPostCode'].value,
          sPhoneNumber: _Item.controls['sPhoneNumber'].value,
          sFaxNumber: _Item.controls['sFaxNumber'].value,
          sEmail: _Item.controls['sEmail'].value,
          sVendorNamePayee: _Item.controls['sVendorNamePayee'].value,
          sVendorAddressPayee: _Item.controls['sVendorAddressPayee'].value,
          sTAXIDPayee: _Item.controls['sTAXIDPayee'].value,
          nOfficeTypePayee: _Item.controls['nOfficeTypePayee'].value,
          sVendorBranchPayee: _Item.controls['sVendorBranchPayee'].value,
          sCountryIDPayee: _Item.controls['sCountryIDPayee'].value,
          sProvCodePayee: _Item.controls['sProvCodePayee'].value,
          sProvNamePayee: _Item.controls['sProvNamePayee'].value,
          sAmpCodePayee: _Item.controls['sAmpCodePayee'].value,
          sAmpNamePayee: _Item.controls['sAmpNamePayee'].value,
          sTumbonCodePayee: _Item.controls['sTumbonCodePayee'].value,
          sTumbonNamePayee: _Item.controls['sTumbonNamePayee'].value,
          sPostCodePayee: _Item.controls['sPostCodePayee'].value,
          sPhoneNumberPayee: _Item.controls['sPhoneNumberPayee'].value,
          sFaxNumberPayee: _Item.controls['sFaxNumberPayee'].value,
          sEmailPayee: _Item.controls['sEmailPayee'].value,
          sBankNamePayee: _Item.controls['sBankNamePayee'].value,
          sAccountNoPayee: _Item.controls['sAccountNoPayee'].value,
          sBankKeyPayee: _Item.controls['sBankKeyPayee'].value,
          sBankOtherPayee: _Item.controls['sBankOtherPayee'].value,
          sPaymentMethodPayee: _Item.controls['sPaymentMethodPayee'].value + "",
          sPaymentTypePayee: _Item.controls['sPaymentTypePayee'].value,
          sReconAccount: _Item.controls['sReconAccount'].value,
          IsIndividualPayee: _Item.controls['IsIndividualPayee'].value,
          sOtherRefNoFIDocNo: _Item.controls['sOtherRefNoFIDocNo'].value,
          sInvoiceNo: _Item.controls['sInvoiceNo'].value,
          sInvoiceNoDefault: _Item.controls['sInvoiceNoDefault'].value,
          sInvoiceDate: _Item.controls['sInvoiceDate'].value,
          //sInvoiceDesc: _Item.controls['sInvoiceDesc'].value,
          sDescription: _Item.controls['sDescription'].value,
          nExcludeVAT: _Item.controls['nExcludeVAT'].value,
          nVAT: _Item.controls['nVAT'].value,
          nIncludeVAT: (_Item.controls['nIncludeVAT'].value),
          sVATType: _Item.controls['sVATType'].value,
          sWHTType: _Item.controls['sWHTType'].value,
          sWHTCode: _Item.controls['sWHTCode'].value,
          nWHTRate: _Item.controls['nWHTRate'].value,
          nWHTBase: _Item.controls['nWHTBase'].value,
          nWHTVal: _Item.controls['nWHTVal'].value,
          sWHTType2: _Item.controls['sWHTType2'].value,
          sWHTCode2: _Item.controls['sWHTCode2'].value,
          nWHTRate2: _Item.controls['nWHTRate2'].value,
          nWHTBase2: _Item.controls['nWHTBase2'].value,
          nWHTVal2: _Item.controls['nWHTVal2'].value,
          sTAXID: _Item.controls['sTAXID'].value,
          sComment: _this.InputFrom.get('sComment').value,

          ListGL: _Item.controls['ListGL'].value,
          ListPstkey: _Item.controls['ListPstkey'].value

        };
        const options = { headers: { 'Content-Type': 'application/json' } };
        _this.http.post<any>(_this.System.SiteName + "api/AdminAdjust/SaveDraft", JSON.stringify(_Data), options).subscribe(res => {
          _this.System.UnBlockUI();
          if (res.Status == _this.System.SysProcess.SessionExpired) {
            _this.System.SessionExpire();
          }
          else if (res.Status == _this.System.SysProcess.Success) {

            var JSONDATA = JSON.parse(res.Content);
            let GLItem = JSONDATA[0];
            _this.ArrPstKey = JSONDATA[1];

            let ListInvoice = _this.InputFrom.controls["ListInvoice"] as FormArray;
            let FromInvoice = ListInvoice.at(_inx) as FormGroup;
            let ListGL = FromInvoice.controls["ListGL"] as FormArray;
            let ListPstkey = FromInvoice.controls["ListPstkey"] as FormArray;

            let IsVAT = true;
            if (_this.PRMS_GRID) {
              //เช็คกรณี Vat เป้น null
              if (_Item.controls["nVATRate"].value == null || _Item.controls["nVATRate"].value + "" == "") {
                IsVAT = false;
              }
              else {
                IsVAT = true;
              }
            }

            ListGL.clear();
            GLItem.forEach(GL_DATA => {
              ListGL.push(new FormGroup({
                sRequestID: new FormControl(GL_DATA.sRequestID),
                nItemNo: new FormControl(GL_DATA.nItemNo),
                nLineNo: new FormControl(GL_DATA.nLineNo),
                sDescription: new FormControl(GL_DATA.sDescription),
                sGL: new FormControl(GL_DATA.sGL, Validators.required),
                sCCTR: new FormControl(GL_DATA.sCCTR, Validators.required),
                //sIO: new FormControl(GL_DATA.sIO, Validators.required),
                sIO: new FormControl({ value: GL_DATA.sIO, disabled: _this.IsNotFill_IO }, Validators.required),
                sPTC: new FormControl(GL_DATA.sPTC),
                nAmtExcldVAT: new FormControl(_this.System._ParseToDecimal(GL_DATA.nAmtExcldVAT), Validators.required),
                nVAT: new FormControl({ value: _this.System._ParseToDecimal(GL_DATA.nVAT), disabled: !IsVAT }, Validators.required),
                nAmtIncldVAT: new FormControl(_this.System._ParseToDecimal(GL_DATA.nAmtIncldVAT)),
                sText: new FormControl(GL_DATA.sText, Validators.required),
                cActive: new FormControl(GL_DATA.cActive),
                IsVAT: new FormControl(IsVAT),
                sRef: new FormControl(null),
                cSSC_Create: new FormControl(GL_DATA.cSSC_Create),
                nReceiveType: new FormControl(GL_DATA.nReceiveType != null ? GL_DATA.nReceiveType.toString() : "1")
              }));
            })

            ListPstkey.clear();
            FromInvoice.controls["IsOpenPstKey"].setValue(false);

            _this.swal.SwAlert.Success(_this.swal.BoxMsg.Title_Success, _this.swal.BoxMsg.Desc_SaveComplete, function () {
              _Item.controls['ListPstkey'].clear();
             _this.SetDataControl();
              
              Swal.close();
            });
          }
          else {
            _this.swal.SwAlert.Error(_this.swal.BoxMsg.Title_Error, res.Msg, function () { Swal.close(); });
          }
        });
      }, function () {
        Swal.close();
      });
    }
    else {
      var elmnt = document.getElementById("trInvoice_" + _inx).querySelectorAll(".has-error");
      if (elmnt.length > 0) {
        elmnt[0].scrollIntoView();
      }
      else {
        var elmnt = document.getElementById("trGL_" + _inx).querySelectorAll(".has-error");
        if (elmnt.length > 0) {
          elmnt[0].scrollIntoView();
        }
      }
    }
  }
  CheckDraftValidate(_inx): boolean {
    let IsValid = true;
    let FromArray = this.InputFrom.get('ListInvoice') as FormArray;
    let FromGroup = FromArray.at(_inx) as FormGroup;

    Object.keys(FromGroup.controls).forEach(field => {
      const control = FromGroup.get(field);
      if (control instanceof FormControl) {
        if (!control.valid && !control.disabled) {
          IsValid = false;
          control.markAsTouched({ onlySelf: true });
        }
      }
      else if (control instanceof FormArray) {
        let FromArraySub = control as FormArray;
        for (var i = 0; i < FromArraySub.length; i++) {
          const FromGroupSub = FromArraySub.at(i) as FormGroup;
          Object.keys(FromGroupSub.controls).forEach(fieldsub => {
            const controlSub = FromGroupSub.get(fieldsub);
            if (controlSub instanceof FormControl) {
              if (!controlSub.valid && !controlSub.disabled) {
                IsValid = false;
                controlSub.markAsTouched({ onlySelf: true });
              }
            }
          });
        }
      }
    });

    return IsValid;
  }
  AddGL(_Item, _inx) {
    let FromArray = this.InputFrom.get('ListInvoice') as FormArray;
    let FromGroup = FromArray.at(_inx) as FormGroup;
    let ListPstkey = FromGroup.controls["ListPstkey"] as FormArray;
    let IsVAT = true;
    let IsValid = true;
    let _this = this;
    Object.keys(FromGroup.controls).forEach(field => {
      const control = FromGroup.get(field);
      if (control instanceof FormArray) {
        let FromArraySub = control as FormArray;
        for (var i = 0; i < FromArraySub.length; i++) {
          const FromGroupSub = FromArraySub.at(i) as FormGroup;
          Object.keys(FromGroupSub.controls).forEach(fieldsub => {
            const controlSub = FromGroupSub.get(fieldsub);
            if (controlSub instanceof FormControl) {
              if (!controlSub.valid && !controlSub.disabled) {
                if (!(_Item.controls["nItemNo"].value === 1 && this.IsForB2P)) {
                  IsValid = false;
                  controlSub.markAsTouched({ onlySelf: true });
                }
                else if (fieldsub === 'sText' && _Item.controls["nItemNo"].value === 1 && !controlSub.value) {
                  IsValid = false;
                  controlSub.markAsTouched({ onlySelf: true });
                }
              }
            }
          });
        }
      }
    });

    if (IsValid) {
      //เช็คกรณี Vat เป้น null
      if (this.PRMS_GRID) {
        if (_Item.controls["nVATRate"].value == null || _Item.controls["nVATRate"].value + "" == "") {
          IsVAT = false;
        }
        else {
          IsVAT = true;
        }
      }

      let FromGL = FromGroup.get('ListGL') as FormArray;
      FromGL.push(new FormGroup({
        sRequestID: new FormControl(_Item.controls["sRequestID"].value),
        nItemNo: new FormControl(_Item.controls["nItemNo"].value),
        nLineNo: new FormControl(null),
        sDescription: new FormControl(null),
        sGL: new FormControl(null, Validators.required),
        sCCTR: this.IsForB2C ? new FormControl(null) : new FormControl(null, Validators.required),
        sIO: this.IsForB2C ? new FormControl(null) : new FormControl(null, Validators.required),
        //sIO: new FormControl({ value: null, disabled: _this.IsNotFill_IO }, Validators.required),
        sPTC: new FormControl(null),
        nAmtExcldVAT: new FormControl(null, Validators.required),
        nVAT: this.IsForJV ? new FormControl(null) : new FormControl({ value: null, disabled: !IsVAT }, Validators.required),
        nAmtIncldVAT: new FormControl(null),
        sText: new FormControl(null, Validators.required),
        cActive: new FormControl("Y"),
        IsVAT: new FormControl(IsVAT),
        sRef: new FormControl(null),
        cSSC_Create: new FormControl("Y"),
        nReceiveType: new FormControl("1")
      }));

      FromGroup.get("NoData").setValue(false);
    }
    ListPstkey.clear();
    FromGroup.controls["IsOpenPstKey"].setValue(false)

  }
  DeleteGL(_inx, _inxSub) {
    let _This = this;
    this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Delete, this.swal.BoxMsg.Desc_Confirm_Delete, function () {
      let FromArray = _This.InputFrom.get('ListInvoice') as FormArray;
      let FromGroup = FromArray.at(_inx) as FormGroup;
      let FromGL = FromGroup.get('ListGL') as FormArray;
      let ListPstkey = FromGroup.controls["ListPstkey"] as FormArray;
      ListPstkey.clear();
      FromGL.at(_inxSub).get("cActive").setValue("N");
      let FormGLGroup = FromGL.at(_inxSub) as FormGroup;
      Object.keys(FormGLGroup.controls).forEach(_Field => {
        //FormGLGroup.controls[_Field].setValue("");
        FormGLGroup.controls[_Field].setErrors(null);
        FormGLGroup.controls[_Field].clearValidators();
      })
      //Check NoData
      let NoData = FromGL.value.filter(f => f.cActive == "Y") == 0;
      FromGroup.controls["NoData"].setValue(NoData);
    }, function () {
      Swal.close();
    });

  }
  CalculateITEM(_Item, _inx) {
    let nExcludeVAT: any = this.System._ParseFloatToZero(_Item.controls["nExcludeVAT"].value);
    let nVatRate: any = this.System._ParseFloatToZero(_Item.controls["nVATRate"].value);
    let nVat: any = nExcludeVAT * nVatRate;
    let nTotal: any = nExcludeVAT + nVat;
    if (this.IsForB2P) this.CalculateGrandTotal();
    if (_Item.controls["nVATRate"].value) {
      _Item.controls["nVAT"].setValue(this.System._ParseToDecimal(nVat));
    }
    else {
      _Item.controls["nVAT"].setValue(null);
    }
    _Item.controls["nIncludeVAT"].setValue(this.System._ParseToDecimal(nTotal));
  }
  CalculateITEMVat(_Item, _inx) {
    let nExcludeVAT: any = this.System._ParseFloatToZero(_Item.controls["nExcludeVAT"].value);
    let nVat: any = this.System._ParseFloatToZero(_Item.controls["nVAT"].value);
    let nTotal: any = nExcludeVAT + nVat;
    _Item.controls["nIncludeVAT"].setValue(this.System._ParseToDecimal(nTotal));
  }
 
  CalculateITEMLine(_Item, _Item_Sub, _inx) {
    let nExcludeVAT: any = this.System._ParseFloatToZero(_Item_Sub.controls["nAmtExcldVAT"].value);
    let nVatRate: any = this.System._ParseFloatToZero(_Item.controls["nVATRate"].value);
    let nVat: any = nExcludeVAT * nVatRate;
    let nTotal: any = nExcludeVAT + nVat;
    if (_Item.controls["nVATRate"].value) {
      _Item_Sub.controls["nVAT"].setValue(this.System._ParseToDecimal(nVat));
    }
    else {
      _Item_Sub.controls["nVAT"].setValue(null);
    }
    _Item_Sub.controls["nAmtIncldVAT"].setValue(this.System._ParseToDecimal(nTotal));

    let ListPstkey = _Item.controls["ListPstkey"] as FormArray;
    ListPstkey.clear();
    if (this.IsForB2P) this.CalculateGrandTotal();
  }
  CalculateITEMVatLine(_Item, _Item_Sub, _inx) {
    let nExcludeVAT: any = this.System._ParseFloatToZero(_Item_Sub.controls["nAmtExcldVAT"].value);
    let nVat: any = this.System._ParseFloatToZero(_Item_Sub.controls["nVAT"].value);
    let nTotal: any = nExcludeVAT + nVat;
    _Item_Sub.controls["nAmtIncldVAT"].setValue(this.System._ParseToDecimal(nTotal));

    let ListPstkey = _Item.controls["ListPstkey"] as FormArray;
    ListPstkey.clear();
  }
 
  CalculateGrandTotal(){
    let _this = this;
    let list = this.ListInvoice.value;
    if (list) {
      let grandTotal: number = 0;

      if (list.length > 0) {
        if (list[0].nExcludeVAT) {
          grandTotal += _this.System._ParseFloatToZero(list[0].nExcludeVAT);
        }
        if (list[0].nWHTVal) {
          grandTotal -= _this.System._ParseFloatToZero(list[0].nWHTVal);
        }
      }
      if (list.length > 1) {
        let listGL = list[1].ListGL;
        listGL.forEach(item => {
          if (item.nAmtExcldVAT) {
          grandTotal += _this.System._ParseFloatToZero(item.nAmtExcldVAT);
          }
        });
      }
      this.InputFrom.patchValue({
        nGrandTotalAmtInvoice: _this._ConvertToDecimal(grandTotal),
      });
    }
  }

  SaveData(sMode) {
    let _this = this;
    let _FormGroup = this.InputFrom;
    switch (sMode) {
      case "MP":
      case "V":
      case "E":
        if (!this.IsForJV) {
          let _ListInvoice2 = this.InputFrom.getRawValue().ListInvoice;
          let isBreak = false;
          let isBreakBase = false;
          let errorMessage = '';
          let errorArr = [];
          if (!this.IsUploadExcelFile) {
            _ListInvoice2.forEach(function (Item) {
              // if (Item.sWHTType != '' && Item.sWHTCode == '') {
              //   isBreak = true;
              // }
              // if (Item.sWHTType2 != '' && Item.sWHTCode2 == '') {
              //   isBreak = true;
              // }
  
              if(_this.InputFrom.controls["nReqType"].value !== 90) {
                if (Item.nWHTVal != null && Item.nWHTVal != '' && Item.nWHTVal != '0.00' && (Item.sWHTType == '' || Item.sWHTCode == '' || Item.nWHTBase == '')) {
                  if (!isBreak) {
                    if (Item.sWHTType == '') errorArr.push('WHT Type')
                    if (Item.sWHTCode == '') errorArr.push('WHT Code')
                    if (Item.nWHTBase == '') errorArr.push('WHT Base')
                  }
                  isBreak = true;
                }
                if (Item.nWHTVal2 != null && Item.nWHTVal2 != '' && Item.nWHTVal2 != '0.00' && (Item.sWHTType2 == '' || Item.sWHTCode2 == '' || Item.nWHTBase2 == '')) {
                  if (!isBreak) {
                    if (Item.sWHTType2 == '') errorArr.push('WHT 2 Type')
                    if (Item.sWHTCode2 == '') errorArr.push('WHT 2 Code')
                    if (Item.nWHTBase2 == '') errorArr.push('WHT 2 Base')
                  }
                  isBreak = true;
                }
              }
  
              let nExcludeVAT: number = _this.System._ParseFloatToZero(Item.nExcludeVAT);
              let nWHTBase: number = _this.System._ParseFloatToZero(Item.nWHTBase);
              let nWHTBase2: number = _this.System._ParseFloatToZero(Item.nWHTBase2);
  
              let base = _this._ConvertToDecimal((Number(nWHTBase) + Number(nWHTBase2)));
              let totalAmount = _this._ConvertToDecimal((Number(nExcludeVAT)));
  
              if (totalAmount !== base && base !== '0.00' && base !== null) {
                isBreakBase = true;
              }
  
            });
  
            if (isBreak) {
              errorMessage = 'Plese Select ' + errorArr.join(', ');
              this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, errorMessage, undefined)
              break;
            }
            if (isBreakBase) {
              this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, this.swal.BoxMsg.Desc_Base_TotalNoMatch, undefined)
              break;
            }
          }
          }
    
        let Valid = true;
        let FieldVendor: any[] = [
          { _Field: "sDocHeader", _Validator: Validators.required, _Value: "" },
          { _Field: "dDueDate_SSC", _Validator: Validators.required, _Value: "" },
          { _Field: "dPostingDate", _Validator: Validators.required, _Value: "" },
          { _Field: "dTranslationDate", _Validator: null, _Value: 1 },
          { _Field: "sBankName", _Validator: Validators.required, _Value: "" },
          { _Field: "sAccountNo", _Validator: Validators.required, _Value: "" },
          { _Field: "sBusinessPlace", _Validator: Validators.required, _Value: "" },
        ];
        switch (_this.InputFrom.controls['nReqType'].value) {
          case 20:
            FieldVendor.forEach(function (Item) {
              if (!_FormGroup.get(Item._Field).valid && !_FormGroup.get(Item._Field).disabled) {
                Valid = false;
                _FormGroup.get(Item._Field).markAsTouched({ onlySelf: true });
                return false;
              }
            });
            break;
          case 30:
            if (this.IsAdvanceReturnFull) {
              FieldVendor.forEach(function (Item) {
                if (!_FormGroup.get(Item._Field).valid && !_FormGroup.get(Item._Field).disabled) {
                  Valid = false;
                  _FormGroup.get(Item._Field).markAsTouched({ onlySelf: true });
                  return false;
                }
              });
            }
            else {

              Valid = this.validateAllFormFields(this.InputFrom);
            }
            break;
          case 80:
            FieldVendor = [
              { _Field: "sDocHeader", _Validator: Validators.required, _Value: "" },
            ];
            FieldVendor.forEach(function (Item) {
              if (!_FormGroup.get(Item._Field).valid && !_FormGroup.get(Item._Field).disabled) {
                Valid = false;
                _FormGroup.get(Item._Field).markAsTouched({ onlySelf: true });
                return false;
              }
            });
            let FromArray = this.InputFrom.get('ListInvoice') as FormArray;
            let totalDr = 0;
            let totalCr = 0;
            for (let x = 0; x < FromArray.length; x++) {
              let FromGroup = FromArray.at(x) as FormGroup;
              let FromGL = FromGroup.get('ListGL') as FormArray;
              for (let i = 0; i < FromGL.length; i++) {
                let value = 0;
                let str = FromGL.at(i).get('nAmtExcldVAT').value;
                let type = FromGL.at(i).get('nReceiveType').value;
                if (str === '') {
                  str = '0';
                }
                else if (str.substring(str.length - 1) === '.') {
                  str = str.substring(0, str.length - 1);
                }
                value = parseFloat(str);
                if (type === '1') {
                  totalDr += value;
                }
                else {
                  totalCr += value;
                }
              }
            }
            
            if (totalDr != totalCr) {
              this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, this.swal.BoxMsg.Desc_JV_TotalNoMatch, undefined)
              return false;
            }
            break;
          default:
            //this.validateAllFormFields(this.InputFrom);
            Valid = this.validateAllFormFields(this.InputFrom);
            break;
        }

        if (
          _this.InputFrom.controls['nReqType'].value === 10 ||
          _this.InputFrom.controls['nReqType'].value === 11 ||
          _this.InputFrom.controls['nReqType'].value === 12 ||
          _this.InputFrom.controls['nReqType'].value === 40
        ) {
          if (_this.InputFrom.controls['sPaymentType'].value === 1) {
            if (_this.InputFrom.controls['sPaymentMethodName'].value === '' || _this.InputFrom.controls['sPaymentMethodName'].value === null) {
              _this.swal.SwAlert.Error(_this.swal.BoxMsg.Title_Error, 'Please select Payment Method', function () { Swal.close(); });
              break;
            }
          }
        }

        if (Valid) {
          this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Confirm, this.swal.BoxMsg.Desc_Confirm_Save, function () {
            _this.System.BlockUI();
            let _ListInvoice = _this.InputFrom.getRawValue().ListInvoice;
            let _Data = {
              sMode: sMode,
              sRequestID: _this.sRequestID,
              nReqType: _this.InputFrom.controls['nReqType'].value + "",
              sDocHeader: _this.InputFrom.controls['sDocHeader'].value,
              sPostingDate: _this.System._ParseDateToFormat(_this.InputFrom.controls['dPostingDate'].value, ''),
              sDueDate_SSC: _this.System._ParseDateToFormat(_this.InputFrom.controls['dDueDate_SSC'].value, ''),
              sTranslationDate: _this.System._ParseDateToFormat(_this.InputFrom.controls['dTranslationDate'].value, ''),
              sPaymentType: _this.InputFrom.controls['sPaymentType'].value == 1 ? "C" : "T",
              sBankName: _this.InputFrom.controls['sBankName'].value,
              sBankOther: _this.InputFrom.controls['sBankOther'].value,
              sAccountNo: _this.InputFrom.controls['sAccountNo'].value,
              sPaymentMethod: _this.InputFrom.controls['sPaymentMethod'].value + "",
              sBusinessPlace: _this.InputFrom.controls['sBusinessPlace'].value,
              TRequestItems: _ListInvoice,
              sComment: _this.InputFrom.get('sComment').value
            };
            const options = { headers: { 'Content-Type': 'application/json' } };
            _this.http.post<any>(_this.System.SiteName + "api/AdminAdjust/SaveData", JSON.stringify(_Data), options).subscribe(res => {
              _this.System.UnBlockUI();
              if (res.Status == _this.System.SysProcess.SessionExpired) {
                _this.System.SessionExpire();
              }
              else if (res.Status == _this.System.SysProcess.Success) {
                _this.swal.SwAlert.Success(_this.swal.BoxMsg.Title_Success, _this.swal.BoxMsg.Desc_SaveComplete, function () {
                  _this.BindFlow();
                  _this.SetData();
                });
              }
              else {
                _this.swal.SwAlert.Error(_this.swal.BoxMsg.Title_Error, res.Msg, function () { Swal.close(); });
              }
            });
          }, function () {
            Swal.close();
          });
        }
        else {
          var elmnt = document.getElementById("DIV_FormData").querySelectorAll(".has-error");
          if (elmnt.length > 0) {
            elmnt[0].scrollIntoView();
          }
        }
        break;
      case "R":
        if (this.InputFrom.get('sComment').value) {
          this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Confirm, this.swal.BoxMsg.Desc_Confirm_Reject, function () {
            _this.System.BlockUI();
            let _Data = {
              sMode: sMode,
              sRequestID: _this.sRequestID,
              sComment: _this.InputFrom.get('sComment').value
            };
            const options = { headers: { 'Content-Type': 'application/json' } };
            _this.http.post<any>(_this.System.SiteName + "api/AdminAdjust/RejectData", JSON.stringify(_Data), options).subscribe(res => {
              _this.System.UnBlockUI();
              if (res.Status == _this.System.SysProcess.SessionExpired) {
                _this.System.SessionExpire();
              }
              else if (res.Status == _this.System.SysProcess.Success) {
                _this.swal.SwAlert.Success(_this.swal.BoxMsg.Title_Success, _this.swal.BoxMsg.Desc_SaveComplete, function () {
                  //Swal.close();
                  _this.router.navigate(["/admin-task"]);
                });
              }
              else {
                _this.swal.SwAlert.Error(_this.swal.BoxMsg.Title_Error, res.Msg, function () { Swal.close(); });
              }
            });
          }, function () {
            Swal.close();
          });
        } else {
          this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, "Please, specify comment", function () { Swal.close(); });
        }

        break;
    }
    _this.clicked = false;
  }

  GeneratePstkey(_item, _inx) {//หากแก้ฟังช่นนี้ต้องไปปรับส่วนหลังบ้านด้วยใน Systemfunction.GetPostingKey
    let nReqType = this.InputFrom.controls["nReqType"].value;
    let This = this;
    //#region TM_VatPstkey
    let IsGenPstkey: boolean = false;
    let IsGenTaxCodeVendor: boolean = false;
    let IsGenTaxCodeGL: boolean = false;
    //#endregion
    let sDocHeader = this.InputFrom.controls["sDocHeader"].value;
    //#region Invoice
    let ListInvoice = this.InputFrom.controls["ListInvoice"] as FormArray;
    let FromInvoice = ListInvoice.at(_inx) as FormGroup;
    let nItemNo = FromInvoice.controls["nItemNo"].value;
    let sVATType = FromInvoice.controls["sVATType"].value;
    let sVendorCode = FromInvoice.controls["sVendorCode"].value;
    let sVendorName = FromInvoice.controls["sVendorName"].value;
    let nExcludeVAT = this.System._ParseToDecimal(FromInvoice.controls["nExcludeVAT"].value);
    let nVAT = this.System._ParseToDecimal(FromInvoice.controls["nVAT"].value);
    let nIncludeVAT = this.System._ParseToDecimal(FromInvoice.controls["nIncludeVAT"].value);
    let nInvoiceType = FromInvoice.controls["nInvoiceType"].value;
    //let InvoiceDesc = FromInvoice.controls["sInvoiceDesc"].value;
    let sDescriptionMain = FromInvoice.controls["sDescription"].value;
    // let EDT_ITEM = this.ArrEdtItemText.filter(w => w.nItemNo == nItemNo);
    // if (EDT_ITEM.length > 0) {
      //InvoiceDesc = EDT_ITEM[0].sText;
      // sDescriptionMain = EDT_ITEM[0].sText;
    // }
    let sPstKy = "";
    let sPstKy40 = "40";
    let _sPstKy40 = "40";
    //#endregion

    //#region CheckVlidate Invoice
    let IsValid = true;
    Object.keys(FromInvoice.controls).forEach(field => {
      const control = FromInvoice.get(field);
      if (control instanceof FormArray) {
        let FromArraySub = control as FormArray;
        for (var i = 0; i < FromArraySub.length; i++) {
          const FromGroupSub = FromArraySub.at(i) as FormGroup;
          Object.keys(FromGroupSub.controls).forEach(fieldsub => {
            const controlSub = FromGroupSub.get(fieldsub);
            if (controlSub instanceof FormControl) {
              if (!controlSub.valid && !controlSub.disabled) {
                IsValid = false;
                controlSub.markAsTouched({ onlySelf: true });
              }
            }
          });
        }
      }
    });
    //#endregion
    if (IsValid) {
      let ListGL = FromInvoice.controls["ListGL"] as FormArray;
      let ListPstkey = FromInvoice.controls["ListPstkey"] as FormArray;

      if (ListPstkey.length == 0) {
        let sRefCode: string = "";
        let _sDescription: string = "";
        let nPstKeyID: number = null;

        let _VATPST = this.ArrVatPstKey.filter(w => w.sVatType == sVATType);
        if (_VATPST.length > 0) {
          IsGenPstkey = _VATPST[0].IsGenPstkey;
          IsGenTaxCodeVendor = _VATPST[0].IsGenTaxCodeVendor;
          IsGenTaxCodeGL = _VATPST[0].IsGenTaxCodeGL;
          sRefCode = _VATPST[0].sGL;
          _sDescription = _VATPST[0].sDescription;
        }

        ListPstkey.clear();
        //let VendorTaxCode = IsGenTaxCodeVendor ? sVATType : "";
        let VendorTaxCode = sVATType;
        let _Pstkey31: any = [];
        let sText31 = "";
        let nLineNo = 0;
     

        //#region GenPstKey
        //#region Pstkey40
        let ListPstkey40: any = [];
        let ListPstkey31: any = [];
        let sRef = "";
      
        //#endregion
        var count = 0;
        ListGL.controls.forEach(_ITEM => {
          sRef = "";
          nPstKeyID = null;
          let FromGL = _ITEM as FormGroup;
          //let GLTaxCode = IsGenTaxCodeGL ? sVATType : "";
          let GLTaxCode = !IsGenPstkey ? sVATType : "";
          nLineNo = FromGL.controls["nLineNo"].value;
          if (!nLineNo) {
            sRef = new Date().toISOString().slice(0, 19);
            FromGL.controls.sRef.setValue(sRef);
          }
          let sGL = FromGL.controls["sGL"].value;
          let sDescription = FromGL.controls["sDescription"].value;
          let nAmtExcldVAT = this.System._ParseToDecimal(FromGL.controls["nAmtExcldVAT"].value);
          let nVAT = FromGL.controls["nVAT"].value;
          let nAmtIncldVAT = this.System._ParseToDecimal(FromGL.controls["nAmtIncldVAT"].value);
          let sText = this.System._IsNullOrEmpty(FromGL.controls["sText"].value) ? sDescription : FromGL.controls["sText"].value; //กรณียังไม่มีการสร้าง PstKey ดึงมาจาก Invoice Description
          let IsDelete = FromGL.controls["cActive"].value == "Y" ? false : true;
          let IsVAT = FromGL.controls["IsVAT"].value;
          let nReceiveType = FromGL.controls["nReceiveType"].value;
          switch (nReqType) {
            case 10://Pay to Payment
            case 11://Pay to Onetime
            case 50://Other
              sPstKy = "31";
              if (nAmtIncldVAT) if (nAmtIncldVAT.indexOf('-') > -1) sPstKy = "21";
              if (nAmtIncldVAT) if (nAmtIncldVAT.indexOf('-') > -1) sPstKy40 = "50";
              break;
            case 60://Pay to Vendor (CN Type)
            case 61://Pay t Oonetime (CN Type)
              sPstKy = "21";
              sPstKy40 = "50";
              _sPstKy40 = "50";
              break;
            case 70://Billing to Cash
            case 71:
              if (this.nReceiveType == 1 || this.nReceiveType == 2) {
                sPstKy = "01";
                sPstKy40 = "50";
                _sPstKy40 = "50";
              }
              else {
                sPstKy = "11";
                sPstKy40 = "40";
                _sPstKy40 = "40";
              }
              if (nAmtIncldVAT) if (nAmtIncldVAT.indexOf('-') > -1) sPstKy = "11";
              if (nAmtIncldVAT) if (nAmtIncldVAT.indexOf('-') > -1) sPstKy40 = "40";
              break;
            case 12://Pay to Employee
            case 40://Petty Cash
              //กรณีที่เป็น No Vat ระบบจะไปดึงขา EMP มาให้
              switch (nInvoiceType) {
                case 1:
                  //ตรวจสอบเรื่องเงิน
                  sPstKy = "31";
                  if (nAmtIncldVAT) if (nAmtIncldVAT.indexOf('-') > -1) sPstKy = "21";
                  if (nAmtIncldVAT) if (nAmtIncldVAT.indexOf('-') > -1) sPstKy40 = "50";
                  break;
                case 2:
                  sPstKy = "31";//ขา EMP เป็นขา 31 แจ้งแก้ไขวันที่ 05-10-2020 
                  if (nAmtIncldVAT) if (nAmtIncldVAT.indexOf('-') > -1) sPstKy = "21";
                  if (nAmtIncldVAT) if (nAmtIncldVAT.indexOf('-') > -1) sPstKy40 = "50";
                  let EMP_DATA = this.ArrRequestItems.filter(f => f.cVenderMaster == "M");
                  if (EMP_DATA.length > 0) {
                    sVendorCode = EMP_DATA[0].sVendorCode;
                    sVendorName = EMP_DATA[0].sVendorName;
                  }
                  break;
              }
              break;
            case 30:
              //กรณีที่เป็น No Vat ระบบจะไปดึงขา EMP มาให้
              switch (nInvoiceType) {
                case 1:
                  ////ตรวจสอบเรื่องเงิน
                  //let nAdvanceAmount = this.System._ParseFloatToZero(this.ArrRequest.nAdvanceAmount);
                  //let nCumulativeAmount = this.System._ParseFloatToZero(this.ArrRequest.nCumulativeAmount);
                  //let nClearingAmount = this.System._ParseFloatToZero(this.ArrRequest.nClearingAmount);
                  //let nPayment = nCumulativeAmount + nClearingAmount;
                  //if (nPayment > nAdvanceAmount) {//ใช้จริง > เงินยืม
                  //  sPstKy = "39";
                  //}
                  //else {
                  //  sPstKy = "31";
                  //}
                  sPstKy = "31";
                  if (nAmtIncldVAT) if (nAmtIncldVAT.indexOf('-') > -1) sPstKy = "21";
                  if (nAmtIncldVAT) if (nAmtIncldVAT.indexOf('-') > -1) sPstKy40 = "50";
                  break;
                case 2:
                  sPstKy = "39";//ขา EMP เป็นขา 39
                  if (nAmtIncldVAT) if (nAmtIncldVAT.indexOf('-') > -1) sPstKy = "21";
                  if (nAmtIncldVAT) if (nAmtIncldVAT.indexOf('-') > -1) sPstKy40 = "50";
                  let EMP_DATA = this.ArrRequestItems.filter(f => f.cVenderMaster == "M");
                  if (EMP_DATA.length > 0) {
                    sVendorCode = EMP_DATA[0].sVendorCode;
                    sVendorName = EMP_DATA[0].sVendorName;
                  }
                  break;
                case 3://Return Full ไม่มีการ Gen PstKey
                  break;
              }
  
              break;
            case 80://JV
              if(nReceiveType === '1'){
                sPstKy40 = "40";
                _sPstKy40 = "40";
              }
              else{
                sPstKy40 = "50";
                _sPstKy40 = "50";
              }
              break;
          }

          if (count === 0) {
            //#region Pstkey31
            _Pstkey31 = this.ArrPstKey.filter(w => w.sRequestID == this.sRequestID && w.nItemNo == nItemNo && w.sPstKy == sPstKy && w.sRefType == "V" && w.IsDelete == false);
            if (_Pstkey31.length > 0) {
              nPstKeyID = _Pstkey31[0].nPstKeyID;
              sText31 = _Pstkey31[0].sText;
            }
            else {
              sText31 = sText;//กรณียังไม่มีการสร้าง PstKey ดึงมาจาก Invoice Description
            }
            if (nReqType != 80) {
              ListPstkey31.push(
                new FormGroup({
                  group: new FormControl(sPstKy + sRefCode),
                  nPstKeyID: new FormControl(nPstKeyID),
                  sRequestID: new FormControl(this.sRequestID),
                  nItemNo: new FormControl(nItemNo),
                  nLineNo: new FormControl(null),
                  sPstKy: new FormControl(sPstKy),
                  sRefType: new FormControl("V"),
                  sRefCode: new FormControl(sVendorCode),
                  sPstType: new FormControl(null),
                  sDescription: new FormControl(sVendorName),
                  nAmountInDoc: new FormControl(nAmtIncldVAT),
                  sVATType: new FormControl(VendorTaxCode),
                  nTaxBase: new FormControl({ value: null, disabled: true }, Validators.required),
                  sText: new FormControl({ value: sText31, disabled: false }),
                  IsDelete: new FormControl(false),
                  IsTaxBase: new FormControl(false),
                  IsText: new FormControl(true),
                  sRef: new FormControl(sRef)
                })
              )
            }
          }


        
          if (!IsDelete) {
            if (this.System._IsNullOrEmpty(sDescription)) {
              let ITEM_GL = this.ArrVendorGL.filter(w => w.GL_ACCOUNT_NO == sGL);
              if (ITEM_GL.length > 0) {
                sDescription = ITEM_GL[0].SHORT_TEXT;
              }
            }
            if (!this.System._IsNullOrEmpty(sGL)) {
              let _Pstkey40 = this.ArrPstKey.filter(w => w.sRequestID == this.sRequestID && w.nItemNo == nItemNo && w.nLineNo == nLineNo && w.sPstKy == sPstKy40 && w.sRefType == "G" && w.IsDelete == false);
              if (_Pstkey40.length > 0) {
                nPstKeyID = _Pstkey40[0].nPstKeyID;
                sText = _Pstkey40[0].sText;
              }

              //let IsTaxBase: boolean = true;
              //if (!IsVAT) {
              //  IsTaxBase = false;
              //}
              let IsTaxBase: boolean = false;
              let nAmountInDoc = nAmtExcldVAT;
              if (sVATType == "U7") {
                nAmountInDoc = nAmtIncldVAT;
              }

              ListPstkey40.push(
                new FormGroup({
                  group: new FormControl(sPstKy + sGL),
                  nPstKeyID: new FormControl(nPstKeyID),
                  sRequestID: new FormControl(this.sRequestID),
                  nItemNo: new FormControl(nItemNo),
                  nLineNo: new FormControl(nLineNo),
                  sPstKy: new FormControl(sPstKy40),
                  sRefType: new FormControl("G"),
                  sRefCode: new FormControl(sGL),
                  sPstType: new FormControl(null),
                  sDescription: new FormControl(sDescription),
                  nAmountInDoc: new FormControl(nAmountInDoc),
                  sVATType: new FormControl(GLTaxCode),
                  //nTaxBase: new FormControl({ value: this.System._ParseToDecimal(nVAT), disabled: !IsVAT }, Validators.required),
                  nTaxBase: new FormControl(null),
                  sText: new FormControl(sText),
                  IsDelete: new FormControl(IsDelete),
                  IsTaxBase: new FormControl(IsTaxBase),
                  IsText: new FormControl(true),
                  sRef: new FormControl(sRef)
                })
              )
            }
          }
        });

        let list1: any = [];
        let list2: any = [];

        ListPstkey31.forEach(Item => {
          list1.push(Item.value)
        });
        ListPstkey31 = [];
        
        ListPstkey40.forEach(Item => {
          list2.push(Item.value)
        });
        ListPstkey40 = [];

        let _this = this;

        var result1 = list1.reduce(function(res, obj) {
          if (!(obj.group in res))
              res.__array.push(res[obj.group] = obj);
          else {
              res[obj.group].nAmountInDoc = Number(_this.System._ParseFloatToZero(res[obj.group].nAmountInDoc));
              res[obj.group].nAmountInDoc += Number(_this.System._ParseFloatToZero(obj.nAmountInDoc));
              res[obj.group].nAmountInDoc = _this._ConvertToDecimal(res[obj.group].nAmountInDoc);
              if (!res[obj.group].sText.includes(obj.sText)) {
                res[obj.group].sText += ', ' + obj.sText
              }
          }
          return res;
        }, {__array:[]}).__array;

        var result2 = list2.reduce(function(res, obj) {
          if (!(obj.group in res))
              res.__array.push(res[obj.group] = obj);
          else {
              res[obj.group].nAmountInDoc = Number(_this.System._ParseFloatToZero(res[obj.group].nAmountInDoc));
              res[obj.group].nAmountInDoc += Number(_this.System._ParseFloatToZero(obj.nAmountInDoc));
              res[obj.group].nAmountInDoc = _this._ConvertToDecimal(res[obj.group].nAmountInDoc);
              if (!res[obj.group].sText.includes(obj.sText)) {
                res[obj.group].sText += ', ' + obj.sText
              }
          }
          return res;
        }, {__array:[]}).__array;

        result1.forEach(Item => {
          ListPstkey31.push(
            new FormGroup({
              nPstKeyID: new FormControl(Item.nPstKeyID),
              sRequestID: new FormControl(Item.sRequestID),
              nItemNo: new FormControl(Item.nItemNo),
              nLineNo: new FormControl(Item.nLineNo),
              sPstKy: new FormControl(Item.sPstKy),
              sRefType: new FormControl(Item.sRefType),
              sRefCode: new FormControl(Item.sRefCode),
              sPstType: new FormControl(Item.sPstType),
              sDescription: new FormControl(Item.sDescription),
              nAmountInDoc: new FormControl(Item.nAmountInDoc),
              sVATType: new FormControl(Item.sVATType),
              nTaxBase: new FormControl({ value: Item.nTaxBase, disabled: true }, Validators.required),
              sText: new FormControl({ value: Item.sText, disabled: false }),
              IsDelete: new FormControl(Item.IsDelete),
              IsTaxBase: new FormControl(Item.IsTaxBase),
              IsText: new FormControl(Item.IsText),
              sRef: new FormControl(Item.sRef)
            })
          )
        });

        result2.forEach(Item => {
          ListPstkey40.push(
            new FormGroup({
              nPstKeyID: new FormControl(Item.nPstKeyID),
              sRequestID: new FormControl(Item.sRequestID),
              nItemNo: new FormControl(Item.nItemNo),
              nLineNo: new FormControl(Item.nLineNo),
              sPstKy: new FormControl(Item.sPstKy),
              sRefType: new FormControl(Item.sRefType),
              sRefCode: new FormControl(Item.sRefCode),
              sPstType: new FormControl(Item.sPstType),
              sDescription: new FormControl(Item.sDescription),
              nAmountInDoc: new FormControl(Item.nAmountInDoc),
              sVATType: new FormControl(Item.sVATType),
              nTaxBase: new FormControl({ value: Item.nTaxBase, disabled: true }, Validators.required),
              sText: new FormControl({ value: Item.sText, disabled: false }),
              IsDelete: new FormControl(Item.IsDelete),
              IsTaxBase: new FormControl(Item.IsTaxBase),
              IsText: new FormControl(Item.IsText),
              sRef: new FormControl(Item.sRef)
            })
          )
        });

        ListPstkey31.forEach(Item => {
          ListPstkey.push(Item);
        });

        ListPstkey40.forEach(Item => {
          ListPstkey.push(Item);
        });

        //#endregion
        //#region Pstkey40 Vat
        if (IsGenPstkey) {
          nPstKeyID = null;
          let sTextVat40: string = "";

          if (nVAT) if (!(nVAT.indexOf('-') > -1)) sPstKy40 = _sPstKy40;

          let _Pstkey40 = this.ArrPstKey.filter(w => w.sRequestID == this.sRequestID && w.nItemNo == nItemNo && w.sPstKy == sPstKy40 && w.sRefType == "T" && w.IsDelete == false);
          if (_Pstkey40.length > 0) {
            nPstKeyID = _Pstkey40[0].nPstKeyID;
            sTextVat40 = _Pstkey40[0].sText;
          }
          else {
            sTextVat40 = sDocHeader;//กรณียังไม่มีการสร้าง PstKey ดึงมาจาก Invoice Description
          }
          ListPstkey.push(
            new FormGroup({
              nPstKeyID: new FormControl(nPstKeyID),
              sRequestID: new FormControl(this.sRequestID),
              nItemNo: new FormControl(nItemNo),
              nLineNo: new FormControl(null),
              sPstKy: new FormControl(sPstKy40),
              sRefType: new FormControl("T"),
              sRefCode: new FormControl(sRefCode),
              sPstType: new FormControl(null),
              sDescription: new FormControl(_sDescription),
              nAmountInDoc: new FormControl(nVAT),
              sVATType: new FormControl(sVATType),
              nTaxBase: new FormControl(this.System._ParseToDecimal(nExcludeVAT), Validators.required),
              sText: new FormControl(sTextVat40),
              IsDelete: new FormControl(false),
              IsTaxBase: new FormControl(true),
              IsText: new FormControl(true),
              sRef: new FormControl(sRef)
            })
          )
        }
        //#endregion
        //#endregion

        FromInvoice.controls["IsOpenPstKey"].setValue(true);
      }
      else {

        //#region Update ItemText กรณี ไม่มี nPstKeyID
        _item.controls.ListPstkey.controls.forEach(_ITEM => {
          let nPstKeyID_VAT40 = _ITEM.controls["nPstKeyID"].value;
          let sRequestID_VAT40 = _ITEM.controls["sRequestID"].value;
          let nItemNo_VAT40 = _ITEM.controls["nItemNo"].value;
          let sPstKy_VAT40 = _ITEM.controls["sPstKy"].value;
          let sRefType_VAT40 = _ITEM.controls["sRefType"].value;
          let IsDelete_VAT40 = _ITEM.controls["IsDelete"].value;
          if (sRequestID_VAT40 == this.sRequestID && nItemNo_VAT40 == nItemNo && sPstKy_VAT40 == sPstKy40 && sRefType_VAT40 == "T" && IsDelete_VAT40 == false) {
            if (nPstKeyID_VAT40) {

            }
            else {
              _ITEM.controls["sText"].setValue(sDocHeader);
            }
          }
        });
        //#endregion

        if (FromInvoice.controls["IsOpenPstKey"].value) {
          FromInvoice.controls["IsOpenPstKey"].setValue(false);
        }
        else {
          FromInvoice.controls["IsOpenPstKey"].setValue(true);
        }
      }
    }
  }
  setReceiveType(_inx, _inxSub, type) {
    let _This = this;
    let FromArray = _This.InputFrom.get('ListInvoice') as FormArray;
    let FromGroup = FromArray.at(_inx) as FormGroup;
    let FromGL = FromGroup.get('ListGL') as FormArray;
    FromGL.at(_inxSub).get("nReceiveType").setValue(type);
  }

  GeneratePstkey_BAK(_item, _inx) {//หากแก้ฟังช่นนี้ต้องไปปรับส่วนหลังบ้านด้วยใน Systemfunction.GetPostingKey Back Up เคสสร้าง Company เท่ากับ GL

    let nReqType = this.InputFrom.controls["nReqType"].value;
    //#region TM_VatPstkey
    let IsGenPstkey: boolean = false;
    let IsGenTaxCodeVendor: boolean = false;
    let IsGenTaxCodeGL: boolean = false;
    //#endregion

    //#region Invoice
    let ListInvoice = this.InputFrom.controls["ListInvoice"] as FormArray;
    let FromInvoice = ListInvoice.at(_inx) as FormGroup;
    let nItemNo = FromInvoice.controls["nItemNo"].value;
    let sVATType = FromInvoice.controls["sVATType"].value;
    let sVendorCode = FromInvoice.controls["sVendorCode"].value;
    let sVendorName = FromInvoice.controls["sVendorName"].value;
    let nExcludeVAT = this.System._ParseToDecimal(FromInvoice.controls["nExcludeVAT"].value);
    let nVAT = this.System._ParseToDecimal(FromInvoice.controls["nVAT"].value);
    let nIncludeVAT = this.System._ParseToDecimal(FromInvoice.controls["nIncludeVAT"].value);
    //#endregion   

    let ListGL = FromInvoice.controls["ListGL"] as FormArray;
    let ListPstkey = FromInvoice.controls["ListPstkey"] as FormArray;

    if (ListPstkey.length == 0) {
      let sRefCode: string = "";
      let _sDescription: string = "";
      let nPstKeyID: number = null;

      let _VATPST = this.ArrVatPstKey.filter(w => w.sVatType == sVATType);
      if (_VATPST.length > 0) {
        IsGenPstkey = _VATPST[0].IsGenPstkey;
        IsGenTaxCodeVendor = _VATPST[0].IsGenTaxCodeVendor;
        IsGenTaxCodeGL = _VATPST[0].IsGenTaxCodeGL;
        sRefCode = _VATPST[0].sGL;
        _sDescription = _VATPST[0].sDescription;
      }

      ListPstkey.clear();
      let VendorTaxCode = IsGenTaxCodeVendor ? sVATType : "";

      let _Pstkey31: any = [];
      let sText31 = "";
      let sKey31 = "31";
      let sKey40 = "40";
      let nLineNo = 0;
      switch (nReqType) {
        case 10:
        case 11:
        case 12:
        case 30:
        case 40:
        case 50:
        case 60:
        case 61:
        case 80:
          //#region Pstkey40
          let ListPstkey40: any = [];
          let ListPstkey31: any = [];
          let sRef = "";
          ListGL.controls.forEach(_ITEM => {
            sRef = "";
            nPstKeyID = null;
            let FromGL = _ITEM as FormGroup;
            let GLTaxCode = IsGenTaxCodeGL ? sVATType : "";
            nLineNo = FromGL.controls["nLineNo"].value;
            if (!nLineNo) {
              sRef = new Date().toISOString().slice(0, 19);
              FromGL.controls.sRef.setValue(sRef);
            }
            let sGL = FromGL.controls["sGL"].value;
            let sDescription = FromGL.controls["sDescription"].value;
            let nAmtExcldVAT = this.System._ParseToDecimal(FromGL.controls["nAmtExcldVAT"].value);
            let nVAT = FromGL.controls["nVAT"].value;
            let sText = this.System._IsNullOrEmpty(FromGL.controls["sText"].value) ? sDescription : FromGL.controls["sText"].value;
            let IsDelete = FromGL.controls["cActive"].value == "Y" ? false : true;
            if (!IsDelete) {
              if (this.System._IsNullOrEmpty(sDescription)) {
                let ITEM_GL = this.ArrVendorGL.filter(w => w.GL_ACCOUNT_NO == sGL);
                if (ITEM_GL.length > 0) {
                  sDescription = ITEM_GL[0].SHORT_TEXT;
                }
              }
              if (!this.System._IsNullOrEmpty(sGL)) {
                let _Pstkey40 = this.ArrPstKey.filter(w => w.sRequestID == this.sRequestID && w.nItemNo == nItemNo && w.nLineNo == nLineNo && w.sPstKy == sKey40 && w.sRefType == "G" && w.IsDelete == false);
                if (_Pstkey40.length > 0) {
                  nPstKeyID = _Pstkey40[0].nPstKeyID;
                  sText = _Pstkey40[0].sText;
                }
                ListPstkey40.push(
                  new FormGroup({
                    nPstKeyID: new FormControl(nPstKeyID),
                    sRequestID: new FormControl(this.sRequestID),
                    nItemNo: new FormControl(nItemNo),
                    nLineNo: new FormControl(nLineNo),
                    sPstKy: new FormControl(40),
                    sRefType: new FormControl("G"),
                    sRefCode: new FormControl(sGL),
                    sPstType: new FormControl(null),
                    sDescription: new FormControl(sDescription),
                    nAmountInDoc: new FormControl(nAmtExcldVAT),
                    sVATType: new FormControl(GLTaxCode),
                    nTaxBase: new FormControl(nVAT, Validators.required),
                    sText: new FormControl(sText),
                    IsDelete: new FormControl(IsDelete),
                    sRef: new FormControl(sRef)
                  })
                )

                //#region Pstkey31
                _Pstkey31 = this.ArrPstKey.filter(w => w.sRequestID == this.sRequestID && w.nItemNo == nItemNo && w.sPstKy == sKey31 && w.sRefType == "V" && w.IsDelete == false);
                if (_Pstkey31.length > 0) {
                  nPstKeyID = _Pstkey31[0].nPstKeyID;
                  sText31 = _Pstkey31[0].sText;
                }

                let nAmountInDoc: any = null;
                if (nAmtExcldVAT || nVAT) {
                  nAmountInDoc = this.System._ParseToDecimal((this.System._ParseFloatToZero(nAmtExcldVAT) + this.System._ParseFloatToZero(nVAT)) + "");
                }

                ListPstkey31.push(
                  new FormGroup({
                    nPstKeyID: new FormControl(nPstKeyID),
                    sRequestID: new FormControl(this.sRequestID),
                    nItemNo: new FormControl(nItemNo),
                    nLineNo: new FormControl(nLineNo),
                    sPstKy: new FormControl(sKey31),
                    sRefType: new FormControl("V"),
                    sRefCode: new FormControl(sVendorCode),
                    sPstType: new FormControl(null),
                    sDescription: new FormControl(sVendorName),
                    //nAmountInDoc: new FormControl(nIncludeVAT),
                    nAmountInDoc: new FormControl(nAmountInDoc),
                    sVATType: new FormControl(VendorTaxCode),
                    nTaxBase: new FormControl(null, Validators.required),
                    sText: new FormControl(sText31),
                    IsDelete: new FormControl(false),
                    sRef: new FormControl(sRef)
                  })
                )
                //#endregion
              }
            }
          });

          ListPstkey40.forEach(Item => {
            ListPstkey.push(Item);
          });
          ListPstkey31.forEach(Item => {
            ListPstkey.push(Item);
          });
          //#endregion
          //#region Pstkey40 Vat
          if (IsGenPstkey) {
            nPstKeyID = null;
            let sTextVat40: string = "";
            let _Pstkey40 = this.ArrPstKey.filter(w => w.sRequestID == this.sRequestID && w.nItemNo == nItemNo && w.sPstKy == sKey40 && w.sRefType == "T" && w.IsDelete == false);
            if (_Pstkey40.length > 0) {
              nPstKeyID = _Pstkey40[0].nPstKeyID;
              sTextVat40 = _Pstkey40[0].sText;
            }
            ListPstkey.push(
              new FormGroup({
                nPstKeyID: new FormControl(nPstKeyID),
                sRequestID: new FormControl(this.sRequestID),
                nItemNo: new FormControl(nItemNo),
                nLineNo: new FormControl(nLineNo),
                sPstKy: new FormControl(sKey40),
                sRefType: new FormControl("T"),
                sRefCode: new FormControl(sRefCode),
                sPstType: new FormControl(null),
                sDescription: new FormControl(_sDescription),
                nAmountInDoc: new FormControl(nVAT),
                sVATType: new FormControl(sVATType),
                nTaxBase: new FormControl(this.System._ParseToDecimal(nExcludeVAT), Validators.required),
                sText: new FormControl(sTextVat40),
                IsDelete: new FormControl(false),
                sRef: new FormControl(sRef),
              })
            )
          }
          //#endregion
          break;
      }
    }
    else {
      ListPstkey.clear();
    }
  }
  UpdateText(_inx, _inxSub) {
    let ListInvoice = this.InputFrom.controls["ListInvoice"] as FormArray;
    let FromInvoice = ListInvoice.at(_inx) as FormGroup;
    let nItemNo = FromInvoice.controls["nItemNo"].value;
    let ListPstkey = FromInvoice.controls["ListPstkey"] as FormArray;
    let This = this;
    ListPstkey.controls.forEach(function (_Item) {
      let FromGroup_PST = _Item as FormGroup;
      let sPstKy: string = FromGroup_PST.controls["sPstKy"].value;
      let sRefType: string = FromGroup_PST.controls["sRefType"].value;
      let nLineNo: number = FromGroup_PST.controls["nLineNo"].value;
      let sText: string = FromGroup_PST.controls["sText"].value;
      let _Pstkey = [];
      switch (sPstKy) {
        case "31":
          _Pstkey = This.ArrPstKey.filter(w => w.sRequestID == This.sRequestID && w.nItemNo == nItemNo && w.sPstKy == sPstKy && w.sRefType == sRefType && w.IsDelete == false);
          break;
        case "40":
          if (sRefType == "G") {
            _Pstkey = This.ArrPstKey.filter(w => w.sRequestID == This.sRequestID && w.nItemNo == nItemNo && w.nLineNo == nLineNo && w.sPstKy == sPstKy && w.sRefType == sRefType && w.IsDelete == false);
          }
          else {
            _Pstkey = This.ArrPstKey.filter(w => w.sRequestID == This.sRequestID && w.nItemNo == nItemNo && w.sPstKy == sPstKy && w.sRefType == sRefType && w.IsDelete == false);
          }
          break;
      }
      if (_Pstkey.length > 0) {
        _Pstkey[0].sText = sText;
      }
    })
  }

  onBack() {
    this.router.navigate(["/admin-task"])
  }
  ExportUniversal() {
    this.System.BlockUI();
    let _this = this;
    let _ListInvoice = _this.InputFrom.controls['ListInvoice'].value;
    let _Data = {
      sMode: "",
      sRequestID: _this.sRequestID,
      nReqType: _this.InputFrom.controls['nReqType'].value + "",
      sDocHeader: _this.InputFrom.controls['sDocHeader'].value,
      sPostingDate: _this.System._ParseDateToFormat(_this.InputFrom.controls['dPostingDate'].value, ''),
      sDueDate_SSC: _this.System._ParseDateToFormat(_this.InputFrom.controls['dDueDate_SSC'].value, ''),
      sTranslationDate: _this.System._ParseDateToFormat(_this.InputFrom.controls['dTranslationDate'].value, ''),
      sPaymentType: _this.InputFrom.controls['sPaymentType'].value == 1 ? "C" : "T",
      sBankName: _this.InputFrom.controls['sBankName'].value,
      sBankOther: _this.InputFrom.controls['sBankOther'].value,
      sAccountNo: _this.InputFrom.controls['sAccountNo'].value,
      sPaymentMethod: _this.InputFrom.controls['sPaymentMethod'].value + "",
      sBusinessPlace: _this.InputFrom.controls['sBusinessPlace'].value,
      TRequestItems: _ListInvoice,
      IsHeader: _this.InputFrom.controls['IsHeader'].value,
      IsColor: _this.InputFrom.controls['IsColor'].value,
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    _this.http.post(_this.System.SiteName + "api/ExportUniversal/GenerateUniversalByDataVerify", JSON.stringify(_Data), { headers, responseType: 'arraybuffer' })
      .subscribe(res => {
        var blob = new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        let fileName = "Universal_" + _this.InputFrom.controls['sRequestCode'].value + ".xlsx"
        if (window.navigator.msSaveOrOpenBlob) { // For IE:
          navigator.msSaveBlob(blob, fileName);
        }
        else {
          const link = document.createElement('a');
          link.target = '_blank'
          var objectUrl = URL.createObjectURL(blob);
          link.href = objectUrl;
          link.setAttribute('download', fileName);
          link.setAttribute('visibility', 'hidden');
          link.click();
        }
        this.System.UnBlockUI();
      });
  }

  ExportExcel(){
    let sendData = JSON.stringify({});
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    
    this.http
      .post(
        this.System.SiteName + "api/AdminAdjust/DownloadExcel?sReqID=" + this.sRequestID,
        sendData,
        { headers, responseType: "arraybuffer" }
      )
      .subscribe((res) => {
        const blob = new Blob([res], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        this.save(blob, this.InputFrom.value.sRequestCode + "_Excel.xlsx");
      });
  }

  save(blob, fileName) {
    if (window.navigator.msSaveOrOpenBlob) {
      // For IE:
      navigator.msSaveBlob(blob, fileName);
    } else {
      // For other browsers:
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);
    }
  }

  OpenAddress(templeteAddress: TemplateRef<any>, _Item, _inx) {
    this.EditInx = _inx;

    let ListInvoice = this.InputFrom.controls["ListInvoice"] as FormArray;
    let FromInvoice = ListInvoice.at(_inx) as FormGroup;

    this.InputFrom.patchValue({
      sVendorName: FromInvoice.controls["sVendorName"].value,
      sVendorAddress: FromInvoice.controls["sVendorAddress"].value,
      sCountryID: FromInvoice.controls["sCountryID"].value,
      sCountryName: FromInvoice.controls["sCountryName"].value,
      sProvCode: FromInvoice.controls["sProvCode"].value,
      sProvName: FromInvoice.controls["sProvName"].value,
      sAmpCode: FromInvoice.controls["sAmpCode"].value,
      sAmpName: FromInvoice.controls["sAmpName"].value,
      sTumbonCode: FromInvoice.controls["sTumbonCode"].value,
      sTumbonName: FromInvoice.controls["sTumbonName"].value,
      sPostCode: FromInvoice.controls["sPostCode"].value
    });

    if (FromInvoice.controls["sCountryID"].value == "213") {
      this.GetProvince();
      this.GetAmphor();
      this.GetTumbon();
    }

    this.modalRef = this.modalService.show(
      templeteAddress,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }
  UpdateAddress() {
    let Pass = true;
    let Field = ["sVendorName", "sVendorAddress", "sCountryName", "sProvName", "sAmpName", "sTumbonName", "sPostCode"];
    let This = this;
    Field.forEach(function (Item) {
      if (!This.InputFrom.get(Item).valid) {
        This.InputFrom.get(Item).markAsTouched({ onlySelf: true });
        Pass = false;
      }
    });

    if (Pass) {
      let ListInvoice = this.InputFrom.controls["ListInvoice"] as FormArray;
      let FromInvoice = ListInvoice.at(this.EditInx) as FormGroup;

      FromInvoice.controls["sVendorName"].setValue(this.InputFrom.controls["sVendorName"].value);
      FromInvoice.controls["sVendorAddress"].setValue(this.InputFrom.controls["sVendorAddress"].value);
      FromInvoice.controls["sCountryID"].setValue(this.InputFrom.controls["sCountryID"].value);
      FromInvoice.controls["sCountryName"].setValue(this.InputFrom.controls["sCountryName"].value);
      FromInvoice.controls["sProvCode"].setValue(this.InputFrom.controls["sProvCode"].value);
      FromInvoice.controls["sProvName"].setValue(this.InputFrom.controls["sProvName"].value);
      FromInvoice.controls["sAmpCode"].setValue(this.InputFrom.controls["sAmpCode"].value);
      FromInvoice.controls["sAmpName"].setValue(this.InputFrom.controls["sAmpName"].value);
      FromInvoice.controls["sTumbonCode"].setValue(this.InputFrom.controls["sTumbonCode"].value);
      FromInvoice.controls["sTumbonName"].setValue(this.InputFrom.controls["sTumbonName"].value);
      FromInvoice.controls["sPostCode"].setValue(this.InputFrom.controls["sPostCode"].value);

      this.EditInx = null;
      this.modalRef.hide();
    }
    else {

    }
  }
  //#endregion

  //#region Validate
  isFieldValid(_Field: string) {
    return !this.InputFrom.get(_Field).valid && this.InputFrom.get(_Field).touched;
  }
  displayFieldCss(_Field: string) {
    return {
      'has-error': this.isFieldValid(_Field),
      'has-feedback': this.isFieldValid(_Field)
    };
  }
  isFieldValidInvoice(_Field: string, _inx) {
    let FromArray = this.InputFrom.get('ListInvoice') as FormArray;
    return !FromArray.at(_inx).get(_Field).valid && FromArray.at(_inx).get(_Field).touched;
  }
  displayFieldCssInvoice(_Field: string, _inx) {
    return {
      'has-error': this.isFieldValidInvoice(_Field, _inx),
      'has-feedback': this.isFieldValidInvoice(_Field, _inx)
    };
  }
  isFieldValidGL(_Field: string, _inx, _inxSub) {
    let FromArray = this.InputFrom.get('ListInvoice') as FormArray;
    let FromGroup = FromArray.at(_inx) as FormGroup;
    let FromGL = FromGroup.get('ListGL') as FormArray;
    let Valid = false;
    if (!FromGL.at(_inxSub).get(_Field).disabled) {
      if (!FromGL.at(_inxSub).get(_Field).valid) {// && FromGL.at(_inxSub).get(_Field).touched
        Valid = true;
      }
    }

    return Valid;
  }
  displayFieldCssGL(_Field: string, _inx, _inxSub) {
    return {
      'has-error': this.isFieldValidGL(_Field, _inx, _inxSub),
      'has-feedback': this.isFieldValidGL(_Field, _inx, _inxSub)
    };
  }
  isFieldValidTax(_Field: string, _inx, _inxSub) {
    let FromArray = this.InputFrom.get('ListInvoice') as FormArray;
    let FromGroup = FromArray.at(_inx) as FormGroup;
    let FromGL = FromGroup.get('ListPstkey') as FormArray;
    return !FromGL.at(_inxSub).get(_Field).valid && FromGL.at(_inxSub).get(_Field).touched;
  }
  displayFieldCssTax(_Field: string, _inx, _inxSub) {
    return {
      'has-error': this.isFieldValidTax(_Field, _inx, _inxSub),
      'has-feedback': this.isFieldValidTax(_Field, _inx, _inxSub)
    };
  }


  validateAllFormFields(formGroup: FormGroup) {

    let Pass = true;

    let Field = ["sVendorName", "sVendorAddress", "sCountryName", "sProvName", "sAmpName", "sTumbonName", "sPostCode"];
    Object.keys(formGroup.controls).forEach(field => {
      if (Field.indexOf(field) < 0) {
        if ((field).endsWith('Payee')) {
          return;
        }
        const control = formGroup.get(field);
        if (control instanceof FormControl) {
          if (!control.valid) {
            if (!control.disabled) {
              Pass = false;
              control.markAsTouched({ onlySelf: true });
              return;
              //
            }
          }
        } else if (control instanceof FormGroup) {
          this.validateAllFormFields(control);
        }
        else if (control instanceof FormArray) {
          for (let i = 0; i < control.length; i++) {
            let FormGroup = control.at(i) as FormGroup;
            this.validateAllFormFields(FormGroup);
          }
        }
      }
    });

    return Pass;
  }
  //#endregion

  async History(sType: string) {
    let IDENC = await this.System.Encrypt(this.sRequestID);
    switch (sType) {
      case "R":
        window.open("approve?str=" + IDENC, '_blank');
        break;
      case "V":
        window.open("detail-verify?str=" + IDENC, '_blank');
        break;
    }
  }

  async seeFIDoc(template: TemplateRef<any>) {
    let cctrData = { sRequestID: this.sRequestID }
    let sendData = JSON.stringify(cctrData)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let data: any;
    if (sendData != null) {
      await this.http.post(this.System.SiteName + "api/AdminReverseFIdoc/GetFIDoc", sendData, { headers, responseType: 'text' }).toPromise().then(Data => data = Data)
      this.arrFIDoc = JSON.parse(data);
      if (this.arrFIDoc) {
        if (this.arrFIDoc.length > 0) {
          this.isShowFIDoc = this.arrFIDoc[0].nFIDoc > 0;
          this.isShowClearingDoc = this.arrFIDoc[0].nClearingDoc > 0;
          this.isShowAdvClearingDoc = this.arrFIDoc[0].nAdvClearingDoc > 0;
          this.isShowRecieveDoc = this.arrFIDoc[0].nRecieveDoc > 0;
        }
      }
    }
    const config: ModalOptions = { class: 'gray modal-xl' };
    this.modalRef = this.modalService.show(template, config);
  }

  async OnCountryselect(event) {
    if (event.item.sCountryID != "213") {
      this._ArrProvince = [];
      this.InputFrom.patchValue({
        sCountryIDPayee: event.item.sCountryID,
        sProvCodePayee: "",
        sProvNamePayee: "",
        sAmpCodePayee: "",
        sAmpNamePayee: "",
        sTumbonCodePayee: "",
        sTumbonNamePayee: "",
        sPostCodePayee: "",
        sPhoneNumberPayee: "",
        sFaxNumberPayee: "",
        sVendorEmailPayee: "",
      })
    } else {
      await this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").toPromise().then(res => {
        if (res) {
          this._ArrProvince = res;
        }
      });
    
      this.InputFrom.patchValue({
        sCountryIDPayee: event.item.sCountryID,
        sProvCodePayee: "",
        sProvNamePayee: "",
        sAmpCodePayee: "",
        sAmpNamePayee: "",
        sTumbonCodePayee: "",
        sTumbonNamePayee: "",
        sPostCodePayee: "",
        sPhoneNumberPayee: "",
        sFaxNumberPayee: "",
        sVendorEmailPayee: "",
      })
    }
   
  }

  async VendorNameChange(event) {
    let _this = this;
    let lstData = event.item;
    let check = this.ArrVendorName.filter(f => f.sVendorName == lstData.sVendorName)[0];
    let sVendorName = this.InputFrom.get('sVendorNamePayee').value;
    if (check != null && !_IsNullOrEmpty(sVendorName)) {
      this._ArrTumbon = [];
      const httpOptions_Amphur = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sProvCode", lstData.sProvCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).toPromise().then(res => {
        if (res) {
          this._ArrAmphur = res;
        }
      });
      const httpOptions_Tumbon = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: new HttpParams()
          .set("sAmpCode", lstData.sAmpCode)
      };
      await this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).toPromise().then(res => {
        if (res) {
          this._ArrTumbon = res;
        }
      });
      let Amp = this._ArrAmphur.filter(f => f.sAmpCode == lstData.sAmpCode)[0];
      let Country = this._ArrCountry.filter(f => f.sCountryID == lstData.sCountryID)[0];
      let prov = this._ArrProvince.filter(f => f.sProvCode == lstData.sProvCode)[0];
      let tumbon = this._ArrTumbon.filter(f => f.sTumbonCode == lstData.sTumbonCode)[0];
      let value = { sCountryID: lstData.sCountryID == null ? "213" : lstData.sCountryID };
      let event = { item: value };
      await this.OnCountryselect(event).then();

      this.InputFrom.patchValue({
        sVendorAddressPayee: lstData.sAddress == null ? "" : lstData.sAddress,
        sTAXIDPayee: _IsNullOrEmpty(lstData.sTAXID) ? "" : lstData.sTAXID,
        nOfficeTypePayee: isNullOrUndefined(lstData.nOfficeType) == true ? 1 : lstData.nOfficeType,
        sVendorBranchPayee: lstData.sBranch,
        sCountryID: lstData.sCountryID == null ? "213" : lstData.sCountryID,
        sCountryNamePayee: isNullOrUndefined(Country) == true ? "ประเทศไทย (Thailand)" : Country.sCountryName,
        sProvCodePayee: lstData.sProvCode == null ? "" : lstData.sProvCode,
        sProvNamePayee: isNullOrUndefined(prov) == true ? "" : prov.sProvname,
        sAmpCodePayee: lstData.sAmpCode == null ? "" : lstData.sAmpCode,
        sAmpNamePayee: isNullOrUndefined(Amp) == true ? "" : Amp.sAmpName,
        sTumbonCodePayee: lstData.sTumbonCode == null ? "" : lstData.sTumbonCode,
        sTumbonNamePayee: isNullOrUndefined(tumbon) == true ? "" : tumbon.sTumbonName,
        sPostCodePayee: lstData.sPostCode,
        sPhoneNumberPayee: lstData.sPhoneNumber,
        sFaxNumberPayee: lstData.sFaxNumber,
        sEmailPayee: lstData.sEmail,

      });
      if (lstData.nOfficeType == 1 || isNullOrUndefined(lstData.nOfficeType) == true) {
        this.InputFrom.controls['sVendorBranchPayee'].disable();
      }
      let sfield = ["sCountryNamePayee", "sProvCodePayee", "sAmpCodePayee", "sTumbonCodePayee", "sProvNamePayee", "sAmpNamePayee", "sTumbonNamePayee", "sEmailPayee"]

      if (lstData.sCountryID === "213") {
        sfield.forEach(function (value) {
          _this.InputFrom.controls[value].enable();
          _this.InputFrom.controls[value].setValidators(value === 'sEmailPayee' ? [Validators.email] : [Validators.required]);
          _this.InputFrom.controls[value].updateValueAndValidity();
        })
      }
      if (lstData.sCountryID == null) {
        sfield.forEach(function (value) {
          _this.InputFrom.controls[value].enable();
          _this.InputFrom.controls[value].setValidators(value === 'sEmailPayee' ? [Validators.email] : [Validators.required]);
          _this.InputFrom.controls[value].updateValueAndValidity();
        })
     
        this.InputFrom.patchValue({
          sCountryIDPayee: "213",
          sCountryNamePayee: "ประเทศไทย (Thailand)",
          sProvCodePayee: "",
          sAmpCodePayee: "",
          sTumbonCodePayee: "",
          sPostCodePayee: "",
          sPhoneNumberPayee: "",
          sFaxNumberPayee: "",
          sVendorEmailPayee: "",
        })
        //ProvCode
        await this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").toPromise().then(res => {
          if (res) {
            this._ArrProvince = res;
          }
        });
      }
    } else {
      lstData = {};
      this.InputFrom.patchValue({
        sCountryIDPayee: "213",
        sVendorAddressPayee: null,
        sTAXIDPayee: null,
        nOfficeTypePayee: 1,
        sVendorBranchPayee: null,
        sProvCodePayee: "",
        sProvNamePayee: "",
        sAmpCodePayee: "",
        sAmpNamePayee: "",
        sTumbonCodePayee: "",
        sTumbonNamePayee: "",
        sPostCodePayee: "",
        sPhoneNumberPayee: "",
        sFaxNumberPayee: "",
        sVendorEmailPayee: "",
      })
    }  
  }

  onBankBranchSelect(event) {
    this.InputFrom.patchValue({
      sBankKeyPayee: event.item.BANK_KEY,
      sBankKeyNamePayee: event.item.NAME_OF_BANK,
    })
  }

  BankNoResult: any;

  BankNoResults(event: boolean): void {
    this.BankNoResult = event;
  }

  BankOnBlur(item) {
    let bank = this.InputFrom.get('sBankKeyNamePayee').value;
    let ischeck = this.DataBankBranch.filter(f => f.NAME_OF_BANK == bank);
    if (this.BankNoResult == true) {
      this.InputFrom.patchValue({ sBankKeyNamePayee: null });
    } else if (this.BankNoResult == false && ischeck.length > 0) {
      this.onBankBranchSelect(item);
    } else if (this.BankNoResult == false && ischeck.length == 0) {
      this.InputFrom.patchValue({ sBankKeyNamePayee: null });
    }
  }
}

function _IsNullOrEmpty(str) {
  var Result = true;
  if (str && str != "null") {
    Result = false;
  }
  return Result;
}

